import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationJA = {
  title: '法的表示',
  subtitle: 'DDG（ドイツ・デジタルサービス法）第5条に基づく表示',
  serviceProvider: 'サービス提供者',
  contactTitle: '連絡先',
  addressLabel: '住所',
  contactLabel: 'メールアドレス',
  professionalTitle: '会社情報',
  professionLabel: '法人形態',
  businessTypeLabel: '事業内容',
  taxTitle: '税務情報',
  liabilityTitle: '免責事項',
  contentLiabilityTitle: 'コンテンツに関する責任',
  contentLiability: '当社はサービス提供者として、DDG第7条第1項に基づき、当ウェブサイト上の自社コンテンツについて一般法の定めに従い責任を負います。ただし、DDG第8条から第10条により、サービス提供者として、送信または保存された第三者の情報を監視する義務や、違法な活動を示す事情を調査する義務は負いません。',
  linkLiabilityTitle: 'リンクに関する責任',
  linkLiability: '当ウェブサイトには、第三者が運営する外部ウェブサイトへのリンクが含まれています。当社はそれらの内容に影響を及ぼすことができないため、その内容について保証することはできません。リンク先ページの内容については、常に当該ページの提供者または運営者が責任を負います。リンク先のページについては、リンクを設定した時点で法令違反の有無を確認しており、その時点で違法な内容は認められませんでした。',
  copyrightTitle: '著作権',
  copyright: '当ウェブサイトの運営者が作成したコンテンツおよび著作物は、ドイツ著作権法の適用を受けます。著作権法の定める範囲を超える複製、改変、頒布、その他あらゆる利用には、著作者または作成者の書面による同意が必要です。当ウェブサイトのダウンロードおよび複製は、私的かつ非商業的な利用に限り認められます。'
};

export const localeJA = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'ホーム',
    team: 'チーム',
    events: 'イベント',
    finance: '金融AI',
    teaching: '研修',
    agenticdev: 'IDD / エージェント型コーディング',
    iddLegacy: 'レガシーソフトウェアのモダナイゼーション',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: '匿名化',
    quantum: '量子',
    login: 'ログイン',
    openApp: 'アプリを開く',
    account: 'アカウント',
    admin: '管理画面',
    logout: 'ログアウト',
    languageNames: { en: '英語', de: 'ドイツ語', nl: 'オランダ語', uk: 'ウクライナ語', fr: 'フランス語', it: 'イタリア語', es: 'スペイン語', sv: 'スウェーデン語', fi: 'フィンランド語', ja: '日本語', pl: 'ポーランド語', bg: 'ブルガリア語' }
  },
  admin: {
    datalake: {
      loading: "読み込み中 …",
      loadFailed: "データレイクに到達できません",
      refresh: "更新",
      generatedAt: "時点",
      notRolled: "この領域はバックエンドでまだ展開されていません。新しいエンドポイントが稼働し次第、ここに計測された状態が表示されます。",
      loadMore: "さらに読み込む",
      yes: "はい",
      no: "いいえ",
      none: "なし",
      close: "閉じる",
      summaryTitle: "二つの仮説、一つの作業台",
      summaryBody: "アーキテクチャ仮説は言います。数学的な器がモデルの可能性を決める — それは LLM 論文ページにあります。データ仮説は言います。リンクされ検証された学習データだけがその器を満たす — このページはそれに仕えます。オートパイロットはデータ資産を継続的に満たし、論文のデータ計画がすべての領域でドイツ語と英語の両方について達成されると学習を開始し、ベンチマークスイートで結果を計測し、モデルを HuggingFace に非公開で公開します。ここにある数値はすべて計測値か、設定値と明記されたものです。",
      summaryArchButton: "アーキテクチャ仮説へ(LLM 論文)",
      apTitle: "オートパイロット",
      tpTitle: "学習開始までの道のり",
      tpSubtitle: "オートパイロットの現在地：学習が動き出すまでの各ステップを状態・時間・進捗とともに表示します。",
      tpNow: "現在",
      tpStep: "ステップ",
      tpOf: "/",
      tpSince: "開始",
      tpFor: "経過",
      tpHeartbeat: "最終応答",
      tpDone: "完了",
      tpRunning: "実行中",
      tpWaiting: "待機中",
      tpFailed: "失敗",
      tpSkipped: "スキップ",
      tpProgress: "進捗",
      tpRows: "行",
      tpRate: "毎秒",
      tpRemaining: "推定残り時間",
      tpEstimateNote: "計測カウンターからの推定",
      tpPhaseReading: "データパッケージ読み込み中",
      tpPhaseAdmission: "受け入れ（重複・エントロピー）",
      tpPhaseEncoding: "トークン化",
      tpNoTiming: "このエンジンのバージョンはまだ時間を報告しません。",
      tpBlockers: "ブロッカーとエラー",
      tpNone: "ブロッカーはありません。",
      trTitle: "学習実行(ライブ)",
      trSubtitle: "トレーナーの実行ディレクトリから直接読み取ります — worker の再起動中も動作します。",
      trNoRun: "進捗データのある学習実行はまだありません。",
      trStateTraining: "学習中",
      trStateStarting: "起動中",
      trStateFinished: "完了",
      trStateSilent: "{age} 応答なし",
      trStep: "ステップ",
      trOf: "/",
      trRemaining: "残り時間(計測した速度からの推定)",
      trSecondsPerStep: "秒/ステップ",
      trProgress: "計画ステップの進捗",
      trRun: "実行",
      trResumed: "ステップ {step} から再開",
      trVersion: "学習データバージョン",
      trModel: "モデル",
      trTokensPerSecond: "トークン/秒",
      trTokensSeen: "処理済みトークン",
      trVram: "GPU メモリ",
      trCap: "上限",
      trLastHeartbeat: "最新のハートビート",
      trAgo: "{age} 前",
      trShardReads: "シャード読み込み ローカル / worker 経由",
      trLossTitle: "損失(loss)の推移",
      trLossTotal: "合計",
      trLossNtp: "次トークン",
      trLossMtp: "マルチトークン",
      trChartEmpty: "まだステップの報告はありません。",
      trAxisNote: "横軸: 学習ステップ、縦軸: 損失(自然対数)。曲線にマウスを重ねるとそのステップの値を表示します。",
      trValue: "値",
      trCurrentValue: "現在",
      trPoints: "計測点 合計 {count}",
      trStages: "カリキュラムの段階",
      trStageFoundation: "基盤(生テキスト)",
      trStageCapability: "能力",
      trStageAnneal: "アニール",
      trStageCurrent: "実行中",
      trStageDone: "完了",
      trStageAhead: "これから",
      trShards: "シャード",
      trRows: "行",
      trCheckpoint: "最新のチェックポイント",
      trCheckpointNone: "まだありません",
      trCheckpoints: "ディスク上の完全なチェックポイント",
      trCheckpointEvery: "{minutes} 分ごと",
      trKernels: "有効なカーネル",
      trDeviations: "逸脱",
      trBlockStorage: "ブロックストレージ上のコピー",
      trBlockStorageNone: "まだありません — 最初のチェックポイントの後に作成されます",
      trUploading: "アップロード中: ステップ {step}",
      treeCkRun: "学習実行",
      treeCkCopy: "ブロックストレージ上のチェックポイント({time} にコピー)",
      treeCkLocal: "サーバーのディスク上のチェックポイント",
      treeCkUploading: "ブロックストレージへコピー中",
      trKpiProgress: "進捗",
      trKpiTokens: "トークン",
      trKpiThroughput: "スループット",
      trKpiLoss: "損失",
      trKpiLr: "学習率",
      trKpiGpu: "GPU メモリ",
      trEndAt: "終了予定 {time} 頃",
      trSeenPlanned: "処理済み / 計画",
      trBest: "最良 {value}",
      trHourAgo: "1 時間前比 {value}",
      trPerplexity: "パープレキシティ {value}",
      trPhaseWarmup: "ウォームアップ",
      trPhaseCosine: "コサイン減衰",
      trPhaseStable: "安定フェーズ",
      trPhaseDecay: "クールダウン",
      trKpiEpoch: "エポック",
      trEpochValue: "{epochs} 中 {epoch}",
      trPlanTitle: "学習計画",
      trPlanExplain: "ピーク学習率までウォームアップし、その後コーパスの混合4エポックの間は一定。クールダウンでは最も高品質な混合（能力サンプル、教科書テキスト、anneal）で学習し、学習率をゼロまで下げます。",
      trPlanPhase: "フェーズ",
      trPlanStableSteps: "安定フェーズの計画ステップ数",
      trPlanDecay: "クールダウン",
      trPlanDecayAhead: "ステップ {step} から・約 {time} 後",
      trPlanDecayAheadNoTime: "ステップ {step} から",
      trPlanDecayRunning: "ステップ {step} 以降・学習率ゼロまで {steps} ステップ",
      trPlanTokensPerStep: "最適化ステップあたりのトークン",
      trPlanTokensPerStepValue: "{tokens}（{accum} マイクロバッチ）",
      trPlanRecompute: "活性の再計算",
      trPlanRecomputeOn: "オン – 大きいマイクロバッチで速いと測定",
      trPlanRecomputeOff: "オフ – なしの方が速いと測定",
      trPlanFim: "これまでの fill-in-the-middle 形式の文書",
      tbTitle: "教科書プログラム",
      tbSubtitle: "教師モデルが教科書テキストに書き直した foundation テキスト。すべての数値と固有名詞は元の文書に含まれていなければなりません。",
      tbTokens: "教科書トークン",
      tbTokensSub: "目標 {target} の {pct} %",
      tbSamples: "採用された書き直し",
      tbJobs: "完了したジョブ",
      tbTeacher: "教科書トークンあたりの教師トークン",
      tbCost: "教科書トークン100万あたりのコスト",
      tbCostNone: "ゲートウェイはコストを報告しません。教師トークンを数えます",
      tbExplain: "学習と並行して実行。後のエポックとクールダウンは、その時点で封印済みのものを読みます。",
      trThroughputTitle: "スループット(トークン/秒)",
      trCurriculumTitle: "カリキュラム",
      trStageTokens: "{tokens} トークン",
      trStageBegins: "ステップ {step} から開始",
      trPlanWarningLabel: "注意",
      trPlanWarning: "この実行は「{stage}」段階のまま {max} ステップで終了します — 能力データはステップ {cap} からしか始まりません。全体を一巡するには {steps} ステップ(約 {days} 日)が必要です。",
      trPlanOk: "計画ステップは「{stage}」段階まで到達します。",
      trCheckpointsTitle: "チェックポイント",
      trNextCheckpoint: "次のチェックポイント",
      trInSpan: "{span} 後",
      trResumes: "再開",
      trNoResume: "なし",
      trConfig: "設定",
      trHealth: "状態",
      trMicroBatch: "マイクロバッチ / ステップあたりトークン",
      trSeqLen: "シーケンス長",
      trLrPlan: "学習率計画",
      trLrPlanValue: "ピーク {lr}、ウォームアップ {warmup} ステップ、ステップ {max} までコサイン",
      trSpikes: "損失スパイク(直近 1 時間)",
      trProgressSub: "ステップ {step} / {max} · 学習開始から {elapsed}",
      trTokensSub: "計画 {planned} のうち",
      trPathTrainingDetail: "{pct} % · ステップ {step} / {max} · 終了予定 {end} 頃",
      trReadinessRunning: "学習中: {pct} % 完了(ステップ {step} / {max})、損失 {loss}、終了予定 {end} 頃。",
      tdvDraftsHistory: "古い下書き(未封印)({count})",
      runsHistory: "中断・失敗した実行({count})",
      trAxisStep: "学習ステップ",
      trAxisLoss: "損失(自然対数)",
      trCountdown: "{d} 日 {h} 時間 {m} 分 {s} 秒",
      trTimerWaiting: "タイマーは最初の計測後に表示されます。",
      trTimerStageEnds: "段階「{stage}」の終了まで",
      trTimerAt: "{time} に",
      trTimerNext: "その後「{stage}」: {span}、{time} から",
      trTimerRunEnds: "実行終了まで {span}({time} に)",
      trStepTimeSub: "1ステップ {wall} 秒(実測)· 計算時間 {compute} 秒",
      trEtaTitle: "実測ステップ時間から求めた残り時間",
      trEtaEpochEnds: "エポック {epoch}/{epochs} 終了まで",
      trEtaEpochAt: "{time} に(ステップ {step})",
      trEtaNextEpoch: "エポック {epoch}: {time} から(ステップ {step})",
      trEtaDecay: "冷却フェーズ開始まで {span}({time} に、ステップ {step})",
      trEtaBasis: "根拠: 1ステップ {wall} 秒、直近 {n} ステップの平均({pauses} 回の中断(再起動・停止)を除外)。トレーナー報告の計算時間は 1ステップ {compute} 秒。",
      devTitle: "設計図からの逸脱",
      devNone: "逸脱はありません — 実行は設計図に完全に従っています。",
      devPlanned: "計画どおり",
      devLimit: "制限",
      devSeqLen: "コンテキスト長",
      devSeqLenText: "設計図の {spec} ではなく {trained} トークンのコンテキストで学習しています。長いコンテキストは後の段階で加わります。",
      devFim: "穴埋め(FIM)",
      devFimText: "穴埋め目標(ブロックの {rate} %)は設計図で宣言されていますが、この実行ではまだ有効ではありません。",
      devTermination: "終了プローブ",
      devTerminationText: "終了プローブは学習目標ではなく学習後の独立したモードです。完成したチェックポイントに対して後で実行します。",
      devDecision: "判断目標",
      devDecisionText: "判断目標は有効ですが、この実行の事後学習段階には判断マークが届きませんでした。",
      devKernelOff: "高速化オフ",
      devKernelUnverifiedText: "カーネル「{kernel}」はプローブで検証されなかったため、標準計算で動作しています。",
      devKernelUnavailableText: "カーネル「{kernel}」はこのカードで利用できないため、標準計算で動作しています。",
      devKernelFellBackText: "カーネル「{kernel}」は実行中に標準計算へフォールバックしました({reason})。",
      devOptimizer: "オプティマイザ",
      devOptimizerText: "オプティマイザの状態は 8 ビットではなく bfloat16 です(bitsandbytes 利用不可)。メモリは増えますが数学は同じです。",
      devScale: "モデルサイズ",
      devScaleText: "完全なサイズが計測メモリに収まらなかったため、モデルは設計図サイズの {scale} % でインスタンス化されています。",
      devMediaHeads: "メディアヘッド",
      devMediaHeadsText: "学習データにメディアトークンがないため画像/音声ヘッドは未学習です — テキストストランドでは計画どおりです。",
      devVision: "画像経路",
      devVisionText: "画像経路は構築済みですが、データに画像がないため 0 枚で学習しました。",
      devOther: "その他",
      trStageShare: "この段階の {pct} % 完了",
      cap_tool_calling: "ツール呼び出し",
      cap_deep_reasoning: "深い推論",
      cap_software_engineering: "ソフトウェア開発",
      cap_office_finance: "オフィスと財務",
      cap_doc_understanding: "文書理解",
      tpExplainThresholds: "選択したストランドの各能力について、検証済みの学習例が十分にデータレイクに必要です。目標と計測値を能力ごとに示します。",
      tpThresholdsDetail: "{total} 能力のうち {met} が目標に到達",
      tpThresholdRow: "{measured} 件",
      tpForeignThresholds: "このストランド対象外: {list} — 別のストランドに属し、何もブロックしません。",
      tpStepTokenizerReleaseExplain: "トークナイザはテキストを数値に変換します。一度確定してアーキテクチャに報告し、データとモデルが同じ言語を話すようにします。",
      tpStepTokenizeTdvExplain: "検証済みの全学習例を確定したトークナイザで数値列に変換します。",
      tpStepTokenizeCorpusExplain: "データレイクの全生テキストを数値列に変換します — 基盤段階の素材です。",
      tpStepTdvCreateExplain: "トークン化した全データから固定の学習データバージョン(TDV)を組み立てます。カリキュラムと計測トークン量付きです。",
      tpStepTdvSealExplain: "バージョンを不変にし、説明付きでブロックストレージにコピーします。",
      tpStepCompatExplain: "12 のルールでバージョンとアーキテクチャの整合(トークナイザ、コンテキスト長、目標、メモリ)を検査します。すべて緑が必要です。",
      tpStepVramExplain: "宣言された必要量に対して GPU メモリが十分に空いているかをカード上で計測します。",
      tpVramDetail: "空き {free} GB、必要 {need} GB",
      tpStepTrainStartExplain: "すべての前提条件が満たされ次第、オートパイロットが学習実行を開始します。",
      tpStepTrainingExplain: "実行は 30 分ごとのチェックポイントで自律的に学習し、中断後は自動で再開します。詳細は「学習とリリース」ページ。",
      tpVramRunning: "実行中の学習がカードを使用中(必要 {need} GB)。開始時に充足",
      trPathTrainingDetailNoEnd: "{pct} % · ステップ {step} / {max}",
      srTitle: "モデルストランド別のデータ準備状況",
      srSubtitle: "1 つのストランドが学習している間も、データレイクは他のストランドのデータを準備し続けます — 学習開始なしで、各自の封印済みバージョンまで。",
      srTrainingNow: "学習中",
      srSelected: "選択済み",
      srDataReady: "データ準備完了",
      srPreparing: "準備中",
      srModalities: "入力: {in} · 出力: {out}",
      srThresholds: "目標: {total} 中 {met} 達成",
      srCorpus: "トークン化済みコーパス",
      srCorpusValue: "{shards} データパッケージに {tokens} トークン",
      srVersion: "最新バージョン",
      srNoVersion: "まだありません",
      srLacking: "不足",
      srLacksNothing: "なし — バージョンは自身のストランドの番を待っています",
      srLackThresholds: "目標未達成",
      srLackCodec: "画像/音声コーデック未公開",
      srLackTokenizer: "トークナイザ未報告",
      srLackVersion: "封印済みバージョンなし",
      srSelectedNote: "このストランドは現在学習中です。経路は上に表示されています。",
      srSelectedIdleNote: "このストランドは次の学習に選択されています。経路は上に表示されています。",
      srUnselectedNote: "このストランドは別のストランドが選択されている間は学習を開始しません — それでもデータは完全に準備されます。",
      modText: "テキスト",
      modImage: "画像",
      modAudio: "音声",
      modVideo: "動画",
      tpStepThresholds: "目標の達成",
      tpStepPlan: "論文のデータ計画の達成",
      tpExplainPlan: "論文は、各領域に必要な一意で検証済みのトークン数を定めます。ドイツ語と英語はそれぞれ少なくとも半分を担い、コードは言語なしで数えます。数えるのは重複除去後に受け入れられたトークンで、粗い推定値ではありません。",
      tpPlanDetail: "{total} 領域中 {met} 領域を達成",
      tpPlanRowLang: "{have} / {target} · ドイツ語 {de} / {half} · 英語 {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "未達: {langs}",
      tpLangDe: "ドイツ語",
      tpLangEn: "英語",
      tpPlanProvisional: "これまでのトークナイザで暫定的に計数。決め手は新しく学習したものです。",
      tpStepOwnTokenizer: "ストランド独自のトークナイザ",
      tpStepOwnTokenizerExplain: "ストランドは、コードを含むバランスの取れたコーパスで学習した独自のトークナイザで訓練します。そのトークンで初めてデータ計画が確定的に数えられます。",
      tpPlanCat_knowledge: "知識",
      tpPlanCat_code: "コード",
      tpPlanCat_mathematics: "数学",
      tpPlanCat_domain: "専門テキスト",
      tpPlanCat_textbook: "教科書",
      tpPlanCat_agentic: "エージェント例",
      tpPlanFlow: "流入 {rate}/時間",
      tpPlanEtaDays: "残り約 {n} 日",
      tpPlanEtaHours: "残り約 {n} 時間",
      tpPlanNoFlow: "過去24時間の流入なし",
      tpPlanBinding: "ボトルネック",
      tpBind_download: "ダウンロード",
      tpBind_allowance: "Block Storage の1日あたりのアップロード上限",
      tpBind_ingest: "取り込み",
      tpBind_teachers: "教師モデル",
      thrPlanTitle: "能力ごとのサンプル(計測値)",
      thrPlanNote: "このストランドの目標は論文が定めます。領域ごと、ドイツ語と英語のデータ計画で、学習開始への道筋に示されます。能力ごとのしきい値はデータ計画のないストランドにのみ適用され、ここには各能力の計測値を示します。",
      thrPlanRow: "{samples} サンプル · {tokens} トークン",
      srDataPlan: "論文のデータ計画: {total} 領域中 {met} 領域を達成",
      srLackDataPlan: "データ計画が未達",
      srPlanOpen: "未達: {areas}",
      tpBind_source: "この言語のソースなし",
      tpBind_paused: "ダウンロード一時停止中",
      tdvPlanEmpty: "有効な仕様のデータ版はまだありません。論文のデータ計画が達成されると、オートパイロットが構築して封印します。",
      compatPlanNone: "まだ検査はありません。有効な仕様のデータ版は封印時に検査されます。",
      mixPlanTitle: "論文による配合",
      mixPlanNote: "各学習ステップはこの固定比率で領域を取り込みます。減衰フェーズでは高品質の比率を最大半分まで高めます。能力ごとの配合目標はデータ計画のないストランドにのみ適用されます。",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "状況",
      sitSubtitle: "学習の現状を一目で: 論文の各領域にまだ足りないもの、今動いているもの、その次に来るもの。",
      sitHeadlineDays: "学習開始は最短でも約 {time} 後です。最も時間がかかるのは {area} です(ボトルネック: {bottleneck})。",
      sitHeadlineBlocked: "このままではデータ計画に届きません: {items} にソースがありません。対応中: 公開データセットの調査、または検証付き翻訳。",
      sitHeadlineReached: "データ計画は達成されました。続いてトークナイザ、新しいトークン化、封印、検査です。",
      sitHeadlineUnknown: "残りの流入はまだ計測されていません。",
      sitHold: "さらに、すべての構成要素が検証されるまで開始は停止されています。",
      sitArea: "領域",
      sitTotal: "合計",
      sitFlow: "流入",
      sitLeft: "残り",
      sitBottleneck: "ボトルネック",
      sitNoLanguage: "言語なし",
      sitNoSource: "ソースなし",
      sitReached: "達成",
      sitDays: "{n} 日",
      sitHours: "{n} 時間",
      sitPerHour: "1時間あたり {value}",
      sitPerHourTokens: "1時間あたり {value} トークン",
      sitRunningTitle: "今動いているもの",
      sitDownloads: "ダウンロード",
      sitIngest: "テキスト断片への処理",
      sitTokenize: "トークン化",
      sitGenerate: "教師モデルによる生成",
      sitIdle: "停止中",
      sitNextTitle: "次に来るもの",
      sitNextSteps: "コードを含めてトークナイザを学習 → コーパス全体を再トークン化 → データ版を封印 → 検査 → 学習開始",
      sitProvisional: "量はこれまでのトークナイザで暫定的に数えています。確定値は新しく学習したもので数えます。",
      tpPlanSeeSituation: "領域・言語・残り時間は上の状況に示しています。",
      sitHeadlineBlocks: "学習はまだ開始できません。これから構築が必要な構成要素が不足しています({items})。その間もデータは増えています。",
      sitDuration: "学習期間: 同じネットワークで計測した毎秒 {rate} トークンで {budget} トークンに約 {days} 日。",
      sitBlocksTitle: "学習の構成要素",
      sitStateNotBuilt: "未構築",
      sitStateWaiting: "待機中",
      sitStateReady: "完了",
      sitBlockWaitsFor: "待機中: {items}",
      sitBenchProgress: "検証済みタスク {made} / {total}",
      sitBlockParts: "構築済み: {built} · 未完了: {open}",
      part_graph_bundles: "リンクされた文書",
      part_repository_bundles: "リポジトリ全体",
      part_long_context: "長いコンテキスト",
      part_fine_tuning: "ファインチューニング",
      part_reinforcement_learning: "強化学習",
      part_real_folding: "実際のコンテキスト折りたたみ",
      sitBlock_data: "論文の計画どおりのデータ",
      sitBlock_tokenizer: "コード対応トークナイザ",
      sitBlock_bench: "論文のベンチマークスイート",
      sitBlock_trainer: "トレーナー: ウィンドウ段階、固定予算、固定配合",
      sitBlock_bundles: "バンドル: リンクされた文書とリポジトリ全体",
      sitBlock_post_training: "事後学習: 長文脈、ファインチューニング、報酬学習",
      tpStepTokenizerRelease: "トークナイザーのリリース",
      tpStepTokenizeTdv: "学習サンプルのトークン化",
      tpStepTokenizeCorpus: "コーパスのトークン化",
      tpStepTdvCreate: "データバージョンの作成",
      tpStepTdvSeal: "データバージョンの封印",
      apAfterSealLabel: "封印後に自動で続行",
      apAfterSealOn: "オン",
      apAfterSealOff: "オフ",
      apAfterSealConfirmOn: "封印後に自動で続行しますか？トレーニング開始までの道筋が一時停止なしで進みます：互換性チェック、GPU チェック、トレーニング開始。",
      apAfterSealConfirmOff: "封印後に再び停止しますか？データバージョンの封印後、オートパイロットは確認のために一時停止します。",
      apAfterSealTurnedOn: "トレーニング開始までの道筋は封印後に自動で続行します。",
      apAfterSealTurnedOff: "オートパイロットは封印後に停止します。",
      apAfterSealWaiting: "データバージョンは封印済み – オートパイロットは確認のため一時停止中です。",
      apAfterSealStep: "封印済みデータバージョンの確認",
      apAfterSealHint: "封印後、すべてのデータは処理済みでブロックストレージにあります。スイッチがオフならオートパイロットはそこで確認のため一時停止し、オンなら道筋は自動で続行します。",
      tpStepCompat: "互換性チェック",
      tpStepVram: "VRAMテスト",
      tpStepTrainStart: "学習開始",
      tpStepTraining: "学習実行中",
      apSubtitle: "サイクル全体のスイッチ: データの収集・処理・リンク、例の生成、論文のデータ計画が達成されたら学習、ベンチマーク、非公開での公開。すべての阻害要因はごまかさずに名前を挙げます。",
      apOn: "オートパイロット オン",
      apOff: "オートパイロット オフ",
      apTurnOn: "オートパイロットをオンにする",
      apTurnOff: "オートパイロットをオフにする",
      apConfirmOn: "オートパイロットをオンにしますか？封印済みデータバージョンまでデータを継続的に充実させ、その後「封印後に自動で続行」がオンでない限り確認のため一時停止します。",
      apConfirmOff: "オートパイロットをオフにしますか?実行中の作業は制御されて終了し、何も破棄されません。",
      apEnabled: "オートパイロットをオンにしました",
      apDisabled: "オートパイロットをオフにしました",
      apPause: "一時停止",
      apResume: "再開",
      apResumed: "オートパイロットを再開しました",
      apPausedNote: "オートパイロットを一時停止しました",
      apPausedPill: "一時停止中",
      apPhaseLabel: "フェーズ",
      apPhaseSince: "{time} から",
      apCycleId: "サイクル",
      apBlockedLabel: "ブロック中",
      apCycleTitle: "実行中サイクルの進捗",
      apCycleEmpty: "アクティブなサイクルはありません。",
      colPhase: "フェーズ",
      colPending: "待機",
      colRunning: "実行中",
      colDone: "完了",
      colFailed: "失敗",
      thrTitle: "能力ごとのしきい値",
      thrSubtitle: "この量に達するとオートパイロットは学習データバージョンを封印し学習を開始します。バーは計測された進捗を示します。",
      thrMet: "達成",
      thrNotMet: "未達",
      thrDefault: "初期設定の標準値",
      thrForeign: '選択中の系統の対象外',
      staleSince: 'ワーカーが現在応答していません — 最後に計測した状態：',
      staleHint: 'オートパイロットは継続中です。ワーカーが応答し次第、表示は更新されます。',
      idxTitle: 'ベクトル索引と重複排除',
      idxSubtitle: 'グラフ連結のためのレイク自身のHNSW索引と、重複チャンクシャードの計測された除去。',
      idxConfigured: '索引の設定',
      idxReachable: '索引への到達',
      idxPoints: '索引ポイント数',
      idxBackfill: '埋め込みテーブルからの補充',
      idxBackfillDone: '完了',
      idxBackfillOpen: '実行中 / 未完',
      ddLastPass: '最後の重複排除パス',
      ddChecked: '検査した資産',
      ddDropped: '除去した重複シャード',
      ddRows: '除去したチャンク行',
      ddRemaining: '残る候補',
      ddNone: 'まだパスなし',
      gsTitle: 'グラフ段階',
      gsSubtitle: 'グラフのティーチャー段階 — 埋め込みと主張抽出 — はグラフ由来のサンプル合成のためにあり、そのためチャンクを資産をまたいで幅優先に、ランク順に取ります:ランク 0 はオーナーの文書とツール取り込み、ランク 1 は専門知識の本体(科学、工学、書籍、推論、German Commons、Wikipedia)、ランク 2 は一般テキスト(Wikisource、Gutenberg、ウェブコーパス、書き起こし)、ランク 3 はコード(埋め込みのみ、主張抽出は行わない)。基盤の本体はティーチャー処理なしでトークンコーパスに届きます。',
      gsMeasuredAt: '計測時刻',
      gsRanksTitle: 'ランク順',
      gsRanksEmpty: 'ランク計画はまだ報告されていません。',
      gsColRank: 'ランク',
      gsColLabel: 'ソース区分',
      gsColSources: 'ソース',
      gsColAssets: '資産',
      gsColPendingExtract: '抽出待ち',
      gsColPendingEmbed: '埋め込み待ち',
      gsRankOwner: 'オーナーの文書とツール取り込み',
      gsRankExpert: '専門知識の本体',
      gsRankGeneral: '一般テキスト',
      gsRankCode: 'コード(埋め込みのみ)',
      gsRankShort: 'ランク {n}',
      gsLoopsTitle: '各ループの最新ラウンド',
      gsColLoop: 'ループ',
      gsColSource: 'ソース',
      gsColChunks: '処理済みチャンク',
      gsColClaims: '主張',
      gsColEdges: 'エッジ',
      gsColSeconds: '秒',
      gsColLast: '最新ラウンド',
      gsLoopEmbed: '埋め込み',
      gsLoopExtract: '主張抽出',
      gsLoopLink: 'リンク',
      gsUngrounded: '根拠なし {n}',
      gsNoRound: 'まだラウンドなし',
      gsClaims: '主張の合計',
      gsAssetsWithClaims: '主張のある資産',
      gsDangling: '宙に浮いたチャンクノード',
      gsStuck: '停滞した資産(実行中の取り込みがないまま処理中)',
      gsConcurrency: '抽出の並列度',
      gsOrphansLast: '最後のクリーンアップ',
      gsOrphansNone: 'まだ実行なし',
      gsOrphansStatusCleaned: 'クリーンアップ済み',
      gsOrphansDropped: '削除したノード',
      gsOrphansRemaining: '残り',
      gsOrphansHint: 'ここで行うことはありません。シャードのないチャンクノードがある限り、オートパイロットが上限付きのクリーンアップを自ら計画します。概要には最後の実行が表示されます。',
      thrSamplesBar: "サンプル",
      thrTokensBar: "トークン(推定)",
      thrNoMinimum: "実測値、最小値なし",
      thrEditTitle: "しきい値を編集",
      thrEditSubtitle: "保存はすべてのしきい値を完全に置き換えます。初期設定の標準値は、ここで独自の値が設定されるまでのみ有効です。",
      thrMinSamples: "最小サンプル数",
      thrMinTokens: "最小トークン数(推定)",
      thrEnabled: "有効",
      thrAdd: "行を追加",
      thrSave: "しきい値を保存",
      thrSaved: "しきい値を保存しました",
      thrEmpty: "しきい値はまだ定義されていません — 有効なしきい値がなければオートパイロットは何も封印せず、それをブロックとして報告します。",
      capability: "能力",
      modSignature: "署名",
      removeRow: "削除",
      budgetsTitle: "日次予算",
      budgetsSubtitle: "範囲と日ごとの消費と上限 — 予算は教師呼び出しと埋め込み呼び出しを制限します。",
      budgetScope: "範囲",
      budgetDay: "日",
      budgetSpent: "消費",
      budgetCap: "上限",
      budgetsEmpty: "報告された予算はありません。",
      eventsTitle: "イベント",
      eventsSubtitle: "オートパイロットが最後に行ったこと・報告したこと、新しい順。",
      eventsEmpty: "イベントはまだありません。",
      storageTitle: "クラウドストレージ",
      storageSubtitle: "Block Storage への接続とフォルダ構造の初期化 — 副作用なく繰り返せます。",
      connect: "Block Storage を接続",
      backendLabel: "コールドストアのバックエンド",
      backendBlockStorage: "Block Storage",
      backendLocal: "ローカルストレージ",
      connectedLabel: "接続",
      connectedYes: "接続済み",
      connectedNo: "未接続",
      accountLabel: "アカウント",
      signinValidUntil: "サインインの有効期限",
      oauthClientLabel: "OAuth クライアント",
      clientConfigured: "設定済み",
      clientNotConfigured: "未設定",
      bootstrapRun: "構造を初期化",
      bootstrapDone: "初期化を実行しました",
      bootstrapReportTitle: "最後の実行",
      bootstrapNoRun: "このセッションではまだブートストラップが実行されていません。",
      bootstrapLine: "作成したフォルダ: {folders} · コールドストア内のファイル: {files} · 変更なしの再実行: {idempotent}",
      treeTitle: "フォルダツリー",
      treeSubtitle: "ツリーはバージョン管理された仕様です。ここでフォルダを定義し、オートパイロットは追加のみ可能です。保護されたエンジンフォルダと空でないフォルダはエンジンが理由付きで拒否します。Block Storage での削除は決まったルールに従う場合だけで、例えば古いチェックポイントのコピーです（最新の 2 つは残ります）。全体ダウンロード中は、削除と上書きはその終了まで待機します。",
      treeActiveVersion: "アクティブなバージョン v{version}",
      treePath: "パス",
      treePurpose: "目的",
      treeCreatedBy: "作成者",
      treeShards: "シャード",
      treeBytes: "サイズ",
      treeActions: "操作",
      treeRetire: "廃止",
      treeRetired: "フォルダを廃止しました",
      treeAddFolder: "フォルダを追加",
      treeFolderAdded: "フォルダを作成しました",
      treeVersionsTitle: "バージョン",
      treeEmpty: "フォルダはまだ定義されていません。",
      treePlanned: "計画 — ツリー仕様 v{version}",
      treeFiles: "ファイル数",
      treeSizesMeasured: "サイズの計測：{measured}。カタログが記録していないフォルダを Block Storage で最後に数えた時刻：{walked}。1 GB = 10⁹ バイト。",
      treeSizesNoWalk: "サイズの計測：{measured}。カタログが記録していないフォルダはまだ数えられていません。1 GB = 10⁹ バイト。",
      treeExpand: "サブフォルダ {count} 件を表示",
      treeCollapse: "サブフォルダを隠す",
      treeShowMore: "さらに {count} 件のフォルダを表示",
      treeSourceCatalog: "カタログから：実際に Block Storage にあるオブジェクトのみを数えています",
      treeSourceWalk: "Block Storage の巡回で数えました",
      bsUsageTitle: "Block Storage の容量",
      bsUsageSubtitle: "Block Storage アカウントの使用量、上限、空き容量と、そのうちデータレイクが占める割合です。値は最大で 10 分前のものです。1 GB = 10⁹ バイト。",
      bsUsed: "使用量",
      bsLimit: "上限",
      bsFree: "空き",
      bsNoLimit: "固定の上限なし",
      bsTrash: "ゴミ箱内",
      bsLake: "うちデータレイク",
      bsLakeLine: "{size}（{files} ファイル）· 使用量の {share}",
      bsMeasuredAt: "計測時刻",
      bsNotConnected: "Block Storage が接続されていません。接続されると容量が表示されます。",
      bsBarLake: "データレイク",
      bsBarOther: "アカウントのその他",
      bsDlTitle: "全体ダウンロード",
      bsDlSubtitle: "Block Storage 全体を、アーカイブにせずファイルごとに同じフォルダ構成でダウンロードします。実行中は保護モードが有効です。対象ファイルの削除と上書きは終了まで待機し、新しいファイルは引き続き書き込まれますが、このダウンロードには含まれません。実行中のトレーニングが妨げられることはありません。",
      bsDlButton: "Block Storage 全体をダウンロード",
      bsDlFolderHint: "保存先フォルダを一度選ぶと、そこにサブフォルダが作成されます。すでに完全なファイルはスキップされ、中断したファイルはその長さから再開されます。",
      bsDlScriptHint: "このブラウザはフォルダを書き込めません。同じフォルダ構成を作り、各ファイルを再開可能な形で取得するダウンロードスクリプトが提供されます。",
      bsDlWindowsNames: "Windows が名前に使えない文字（「>」など）は、保存先フォルダでは %3E のような % コードになります。",
      bsDlActiveNote: "{time} からダウンロードが実行中です。上のボタンでこのブラウザで続行できます。完全なファイルはスキップされます。",
      bsDlBuilding: "ファイル一覧を作成中：これまでに {files} ファイル、{size}。",
      bsDlManifest: "ファイル一覧を読み込み中：{total} 件中 {done} 件。",
      bsDlFolder: "保存先フォルダ",
      bsDlFiles: "ファイル",
      bsDlData: "データ量",
      bsDlOf: "{done} / {total}",
      bsDlRate: "速度",
      bsDlEta: "残り時間",
      bsDlEtaUnknown: "計算中",
      bsDlCurrent: "取得中のファイル",
      bsDlSkipped: "完全なため {count} 件をスキップ",
      bsDlFailed: "{count} 件のファイルが失敗",
      bsDlPausedNote: "一時停止中です。再開すると、途中のファイルはその長さから続きを取得します。このページが開いている間、保護モードは維持されます。",
      bsDlPause: "一時停止",
      bsDlContinue: "再開",
      bsDlRetryFailed: "失敗したファイルを再取得",
      bsDlFinish: "完了する",
      bsDlStop: "停止",
      bsDlStateBuilding: "ファイル一覧を準備中",
      bsDlStateRunning: "ダウンロード中",
      bsDlStatePaused: "一時停止中",
      bsDlStateIncomplete: "未完了",
      bsDlStateScript: "スクリプト準備完了",
      bsDlStateFinished: "完了",
      bsDlStateStopped: "終了",
      bsDlStateActive: "実行中",
      bsDlFinished: "{files} 件のファイル（{size}）がすべて保存先フォルダにあります。ダウンロードは完了しました。",
      bsDlFinishedNote: "ダウンロードは完了しました。保留されていた削除と上書きが今実行されます。",
      bsDlStopped: "ダウンロードを停止しました。保留されていた削除と上書きが今実行されます。ダウンロード済みのファイルは残ります。",
      bsDlEnded: "サーバーがダウンロードを終了しました（例えば 30 分間応答がなかった場合）。もう一度クリックすると再び開始し、完全なファイルはスキップされます。",
      bsDlSession: "ログインの有効期限が切れました。再度ログインすると、上のボタンでダウンロードを続行できます。",
      bsDlDiskFull: "保存先フォルダに空き容量がありません。容量を空けてから再開してください。",
      bsDlPickFailed: "保存先フォルダを開けませんでした。",
      bsDlScriptPosix: "Linux・macOS 用スクリプト",
      bsDlScriptWindows: "Windows 用スクリプト",
      bsDlScriptRun: "スクリプトを保存先フォルダに保存し、そこで実行します。Windows では .cmd ファイルをダブルクリックするか、コマンド プロンプトから実行します。Linux と macOS ではターミナルで「sh <ファイル>」。",
      bsDlScriptKeyValid: "スクリプト内のキーは {time} まで、このダウンロードに限り、読み取り専用で有効です。",
      bsDlScriptHeartbeat: "このページが開いている間、ダウンロードが続いていることをサーバーに知らせます。スクリプトが終わったら「完了する」をクリックしてください。",
      bsDlProtection: "保護モード",
      bsDlProtectionState: "状態",
      bsDlProtectionOn: "{time} から有効",
      bsDlProtectionOff: "無効",
      bsDlScope: "ダウンロードの範囲",
      bsDlScopeValue: "{files} ファイル、{size}",
      bsDlDeferredDeletes: "保留中の削除",
      bsDlDeferredOverwrites: "保留中の上書き",
      bsDlAddedSince: "開始後に追加",
      bsDlLastActivity: "最後の応答",
      acqTitle: "データソース",
      acqSubtitle: "キュレーションされたオープンライセンスのソース:ソースごとにライセンス、データ保護評価、言語、モダリティ、バイト目標、計測された進捗。無効化されたソースは黙って欠けるのではなく理由を明示します。",
      acqGdprNote: "GDPR 原則:学習データはオープンライセンスと文書化されたデータ保護評価を持つソースからのみ受け入れます。受信箱のデータはサンプル化の前に PII スクラブを通過します(「PII スクラブ済み」カウンターが示します)。",
      acqSource: "ソース",
      acqModality: "モダリティ · 言語",
      acqLicense: "ライセンス",
      acqProtection: "データ保護",
      acqProgress: "進捗",
      acqDocs: "{count} 件のファイル/オブジェクト受領済み",
      acqTargetReached: "目標達成",
      acqExhausted: "ソース枯渇(リスティングはこれ以上提供しません)",
      acqEnabledPill: "有効",
      acqWaitingBuffer: "待機中: バッファが満杯、アップロードが追いついています",
      acqDisabledPill: "無効",
      acqEnable: "有効化",
      acqDisable: "無効化",
      acqEnabledMsg: "ソースを有効化しました",
      acqDisabledMsg: "ソースを無効化しました",
      acqTargetLabel: "目標 (GB)",
      acqSetTarget: "目標を保存",
      acqTargetSaved: "目標を保存しました",
      acqEmpty: "登録されたソースはまだありません。",
      balanceTitle: "ドイツ語/英語の言語バランス",
      balanceSubtitle: "モダリティと言語ごとのダウンロード済みバイト — シードソースではドイツ語が英語に遅れてはなりません。",
      balanceEmpty: "計測値はまだありません。",
      modText: "テキスト",
      modAudio: "音声",
      modImage: "画像",
      modVideo: "動画",
      prepTitle: "前処理",
      prepSubtitle: "登録された生文書から学習サンプルまでの数えられたパイプライン段階 — すべての数値はカタログから。失敗と非対応項目は名指しされます。",
      prepRegistered: "登録済み",
      prepScrubbed: "PII スクラブ済み",
      prepChunked: "分割済み",
      prepEmbedded: "埋め込み済み",
      prepExtracted: "抽出済み",
      prepLinked: "リンク済み",
      prepSamples: "サンプル",
      prepByLang: "言語ごと",
      prepUnsupported: "非対応",
      prepAwaiting: "処理段階を待機中",
      prepFailures: "失敗",
      inboxTitle: "生データ受信箱",
      assetWhat: "内容",
      assetFromSource: "取得元: {source}",
      assetFromUpload: "手動アップロード",
      mediaParquet: "表形式データ（Parquet）",
      treeShardsHint: "シャードはカタログのParquetデータパッケージです。各行が由来・言語・目的を持つ一つのパッケージで、「目的」列がフォルダーの中身を説明します。",
      mediaWords: {
        text: "テキスト",
        audio: "音声",
        video: "動画",
        image: "画像",
        application: "ファイル",
      },
      inboxSubtitle: "独自の生データをレイクに渡す:ここでアップロードするか、クラウドフォルダ raw/inbox/ に直接置きます。照合がすべてのファイルを登録し、「今すぐ処理」はオートパイロットが自走するのと同じ経路を開始します。",
      uploadButton: "ファイルをアップロード",
      uploadHint: "1 ファイルにつき最大 512 MB。アップロードはコールドストアに格納され、処理時に分割・埋め込みされ、知識グラフにリンクされます。",
      uploadTooLarge: "ファイルが 512 MB を超えています。",
      uploadDone: "ファイルを受け付けました",
      processNow: "今すぐ処理",
      processStarted: "処理を開始しました",
      reconcileNow: "クラウドフォルダを照合",
      reconcileDone: "照合を実行しました",
      unprocessedCount: "未処理 {count} 件",
      inboxEmpty: "受信箱は空です。",
      assetName: "ファイル",
      assetType: "種類",
      assetSize: "サイズ",
      assetState: "状態",
      assetLang: "言語",
      assetRegistered: "登録日時",
      assetStates: {
        raw_stored: "生データ保存済み",
        awaiting_stt: "音声認識待ち",
        awaiting_content_fetch: "アドレスの先にある内容を待機中",
        awaiting_image_codec: "画像コーデック待ち",
        awaiting_audio_codec: "音声コーデック待ち",
        awaiting_video_codec: "動画コーデック待ち",
        chunked: "分割済み・グラフ内",
        processed: "処理済み",
        registered: "登録済み",
        queued: "待機中",
        processing: "処理中",
        ingested: "取り込み済み",
        linked: "リンク済み",
        unsupported: "非対応",
        failed: "失敗",
      },
      graphTitle: "知識グラフ",
      graphSubtitle: "リンクされた生コーパス:カタログから数えたノードとエッジ — これらのつながりから学習サンプルが作られます。",
      graphEmbedded: "埋め込み済みノード",
      graphModel: "埋め込みモデル",
      graphClusters: "クラスター",
      graphAssetsLinked: "リンク済み生データ",
      graphLastLink: "最後のリンク",
      graphNodesTitle: "種別ごとのノード",
      graphEdgesTitle: "種別ごとのエッジ",
      graphEmpty: "グラフはまだ空です — 最初に処理されたファイルとともに育ちます。",
      kindCol: "種別",
      countCol: "件数",
      neighborsTitle: "ノードの近傍",
      nodeIdLabel: "ノード ID",
      neighborsRun: "近傍を取得",
      neighborsEmpty: "近傍は見つかりませんでした。",
      nodeCol: "ノード",
      edgeKindCol: "エッジ",
      weightCol: "重み",
      gapTitle: "カバレッジ・ギャップマトリクス",
      gapSubtitle: "能力・署名・段階ごとの計測在庫と設定済み混合目標の対比 — カタログに対する SQL ビューであり、固定値は一切ありません。",
      tier: "段階",
      gapHave: "実績",
      gapTarget: "目標",
      gapWeight: "重み",
      gapPriority: "優先度",
      targetsTitle: "混合目標を定義",
      targetsSubtitle: "目標には設定者と時刻が記録されます。目標がなければ、マトリクスは正直に空の状態を示します。",
      addTargetRow: "行を追加",
      saveTargets: "目標を保存",
      targetsSaved: "目標を保存しました",
      statusCol: "状態",
      tdvTitle: "封印済みデータ版",
      tdvSubtitle: "データ版は不変で、封印済みシャードから構成されます。新しい版が以前の版を置き換えます。",
      createTdv: "TDV ドラフトを作成",
      tdvCreated: "TDV ドラフトを作成しました",
      tdvId: "TDV",
      tdvName: "名前",
      tdvMembers: "構成メンバー",
      tdvCreatedAt: "作成",
      tdvSealedAt: "封印",
      tdvStatusDraft: "ドラフト",
      tdvStatusSealed: "封印済み",
      sealTdv: "封印する",
      tdvSealed: "TDV を封印しました",
      tdvEmpty: "Train Data Version はまだありません — 封印されたシャードから構成されます。",
      compatTitle: "アーキテクチャとデータの互換性検査",
      compatSubtitle: "二つの機械可読ドキュメントに対する規則 R1–R12。ダッシュボードはエンジンが保存した報告を表示するだけで、独自の判定は行いません。",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "ALL-GREEN ではない",
      compatRun: "検査を実行",
      compatChecked: "検査を実行しました",
      compatSelectTdv: "上の一覧から TDV を選ぶと、その報告が表示されます。",
      compatNoReport: "この TDV には保存済みの互換性報告がまだありません。",
      compatDraftNote: "アーキテクチャのデータインターフェースはドラフトです — トークナイザーとコーデックの成果物はまだ存在しません。検査は最初のトークナイザーリリースと最初の封印済み TDV で有効になります。",
      compatRule: "規則",
      compatTitleCol: "名称",
      compatKind: "種別",
      compatEvidence: "比較された値(証拠)",
      kindHard: "必須",
      kindWarn: "注意",
      reportsTitle: "保存済みの報告",
      reportsEmpty: "互換性報告はまだ保存されていません。",
      phaseLabel: "学習フェーズ",
      phaseA: "フェーズ A — 準備と進化",
      phaseB: "フェーズ B — 学習実行中、アーキテクチャ凍結",
      checklistTitle: "学習準備状況(フェーズ A チェックリスト)",
      checklistSubtitle: "条件はリアルタイムに算出されます。すべての項目が満たされるまで開始は無効のままで、未達の項目はすべて名指しされます。",
      checklistReady: "準備完了",
      checklistUnmet: "未達の項目: {count}",
      checklistUnavailable: "チェックリストに到達できません。",
      itemSatisfied: "達成",
      itemUnsatisfied: "未達",
      startTraining: "フェーズ B を開始",
      strandTitle: '学習ストランド',
      strandSubtitle: 'すべての前提条件が満たされたときにどのモデルストランドを学習するか。未選択のストランドはデータ準備を続けますが、開始はしません。',
      strandSelectedBadge: '選択済み',
      strandExplain: 'オートパイロットは {selected} を学習します。{other} は収集と準備を続けますが、選択されない限り開始しません。',
      strandSwitched: '選択を保存しました。',
      strandSwitchFailed: '切り替えに失敗しました。',
      strandUnavailable: 'このバックエンドはまだストランドを提供していません。次のコアのロールアウト後にセレクターが表示されます。',
      trainingStarted: "フェーズ B を開始しました",
      startBlocked: "開始は無効 — 未達: {items}",
      selectedTdvLabel: "選択されたデータ版",
      computedAt: "算出",
      runsTitle: "学習実行",
      runsSubtitle: "カタログにある実在の実行のみ。シミュレーションによる学習プロセスは存在しません。",
      runId: "実行",
      archVersion: "アーキテクチャ",
      presetCol: "プリセット",
      seqLenCol: "シーケンス長",
      stepCol: "ステップ",
      lossCol: "Loss",
      runStarted: "開始",
      runFinished: "終了",
      runsEmpty: "学習実行はまだありません。",
      abortRun: "中断",
      confirmAbort: "この学習実行を中断しますか?",
      runAborted: "中断を要求しました",
      benchLink: "ベンチマーク",
      benchTitle: "ベンチマークレポート",
      benchSubtitle: "凍結されバージョン管理されたスイートが各学習後に自動実行されます。各レポートはレイクに保存され、ここに表示されます。",
      benchEmpty: "ベンチマークレポートはまだありません。",
      suiteVersion: "スイート",
      benchOpen: "開く",
      benchReportFor: "実行 {run} のベンチマークレポート",
      benchNoMarkdown: "このレポートにはレンダリングされた文書がありません。生の結果を以下に示します。",
      exportsTitle: "エクスポート",
      exportsSubtitle: "ダウンロードは、完了した実在の学習実行のエクスポートに対してのみ存在します。",
      exportId: "エクスポート",
      exportSize: "サイズ",
      exportSha: "SHA-256",
      download: "ダウンロード",
      exportsEmpty: "エクスポートはまだありません — 完了した実在の学習実行からのみ生成されます。",
      hfTitle: "HuggingFace 公開",
      hfSubtitle: "すべてのアップロードは非公開です。アップロード後に API で可視性を検証します。非公開でない結果はエラー状態であり、サイクルを停止します。",
      hfEmpty: "公開はまだありません。",
      hfRepo: "リポジトリ",
      hfState: "状態",
      hfVisibility: "可視性",
      hfPrivateVerified: "非公開 — 検証済み",
      hfUnverified: "未検証",
      hfVerifiedAt: "検証日時",
      connectTitle: "Block Storage を接続",
      connectSubtitle: "ストレージプロバイダーのサインインウィンドウでログインすると、確認したアカウントにストレージが接続されます。",
      webConnectStart: "ストレージプロバイダーで接続",
      webConnectWaiting: "ストレージプロバイダーのサインインウィンドウでの確認を待っています…",
      webConnectHint: "確認後、ストレージは自動的に接続され、このダイアログは自動更新されます。",
      publicIdentity: "公開アプリ ID(rclone、共有クォータ)",
      publicIdentityNote: "ストレージプロバイダーのサインインウィンドウにはリクエスト元アプリとして「rclone」が表示されます — 公開共有の ID です。独自のクライアント ID(GDRIVE_OAUTH_CLIENT_ID)でいつでも置き換えられます。",
      manualHint: "確認後、ブラウザは到達できない localhost ページを表示します。アドレスバーの code= パラメータの値をコピーしてここに貼り付けてください(アドレス全体の貼り付けでも可)。",
      manualCodeLabel: "認可コード",
      manualSubmit: "コードを適用",
      deviceInstead: "代わりにデバイスコードを使用",
      licenseAcceptLink: "Hugging Face でライセンスを承認",
      deviceFlowTitle: "Block Storage を接続(デバイスフロー)",
      deviceFlowSubtitle: "エンジンがプロバイダーのデバイスサインインフローを開始します。確認は別の端末で行い、限定された間隔でポーリングします。",
      deviceFlowStart: "サインインフローを開始",
      deviceFlowCode: "デバイスコード",
      deviceFlowOpenUrl: "確認ページを開く",
      deviceFlowWaiting: "確認を待っています — プロバイダーが指定する間隔でポーリング中です。",
      deviceFlowAuthorized: "接続しました",
      deviceFlowExpired: "デバイスコードの有効期限が切れました — サインインフローをやり直してください。",
      readinessTitle: "トレーニングまでの準備状況",
      readinessSubtitle: "最初のトレーニング実行までの計測された道のりを、段階ごとに示します。",
      readinessCounter: "{total} 件中 {green} 件達成",
      readinessReady: "トレーニング可能",
      unblockLabel: "次のステップ",
      readinessUnavailable: "準備状況の概要はまだバックエンドに展開されていません。エンドポイントが稼働し次第、計測された状態がここに表示されます。",
      stageStates: {
        ok: "達成",
        active: "実行中",
        waiting: "待機中",
        blocked: "ブロック中",
      },
    },
    gt: {
      loading: '…',
      unavailable: '利用不可',
      equilibrium: '最適稼働状態に到達：すべての問い合わせに回答済み、すべてのタスク引き継ぎが処理され、重複発言も排除されています。',
      standby: 'スタンバイ',
      defTitle: 'チーム業務連携・パフォーマンス指標',
      defSubtitle: '全AIロールの業務通信および引き継ぎ品質の定量評価：非生産的な活動ではなく、検証可能な成果に集中します。',
      defPlayers: '対象ロールおよびシステム',
      defPlayersText: 'Webexボットを備えた10の専門AIロール、および課題と統治方針を設定する人間の意思決定者。',
      defStrategies: '通信・業務遂行原則',
      defStrategiesText: '問い合わせへの迅速な回答、明確かつ完全なタスク引き継ぎ、重複の排除、および未完了ワークパッケージの確実な完遂。',
      defPayoff: '純業務貢献度（ネット効用）',
      defPayoffText: '完了したワークパッケージ、正常処理された引き継ぎ、回答済み照会 — 摩擦損失（重複、未処理の引き継ぎ、未回答の照会）を差し引いた純貢献値。',
      defEquilibrium: '最適稼働状態（連携均衡）',
      defEquilibriumText: '目標とする協業状態：すべての照会に期限内で回答し、すべての引き継ぎが受理され、情報の重複送信や放置されたワークパッケージがゼロの状態。',
      playersTitle: 'ロール別パフォーマンス一覧（ポジション）',
      playersSubtitle: 'ロール別の通信・遂行指標：専門発言と引き継ぎ（過去7日間）、および会議と完了ワークパッケージ（過去30日間）。',
      playersHint: '純効用 ＝ 3 × 完了ワークパッケージ ＋ 処理済み引き継ぎ − 摩擦損失（未処理の引き継ぎは2倍減点）。マイナス値は連携ボトルネックを示します。',
      player: 'ロール / ポジション',
      contributions: '投稿',
      meetingTurns: '会議',
      handovers: '引き継ぎ',
      consumedShort: '処理済み',
      refusedShort: '拒否',
      delivery: '配信',
      pausedTurns: '一時停止中のターン',
      pausedTurnsHint: 'モデルがその時点で処理できなかったため、同僚自身のメールボックスに保存されたターン。引き継ぎではありません。',
      closedOpen: '完了 / 未完了',
      noise: '摩擦損失',
      utility: '純貢献度',
      meetingsLine: '会議 {held} 件、発言 {turns} 件、返答のない呼びかけ {u} 件（30日間）。',
      interactionsTitle: 'ロール間タスク引き継ぎ（ハンドオーバー行列）',
      interactionsSubtitle: 'メールボックス間の方向付きタスク引き継ぎ（過去7日間）：件数、到達所要時間、処理済み・拒否件数。',
      interactionsHint: 'タスク引き継ぎは受信者が処理して初めて完了とみなされます。拒否または未処理の引き継ぎはプロセス逸脱として記録されます。',
      interactionsEmpty: 'この期間に引き継ぎはありません。',
      from: '送り手',
      to: '受け手',
      messages: 'メッセージ',
      consumed: '処理済み',
      refused: '拒否',
      deviationsTitle: 'プロセス逸脱および未解決ボトルネック',
      deviationsSubtitle: '現在の連携課題：未回答の照会、未処理のタスク引き継ぎ、重複発言、またはブロックされたワークパッケージ。',
      dev_unanswered_question: '未回答の照会（タイムアウト超過）',
      dev_dead_air: '応答なしのタスク引き継ぎ',
      dev_repetition: '会議での繰り返し',
      dev_meeting_unanswered: '未応答の直接照会',
      dev_work_blocked: '作業がブロックされている',
      dev_handover_hop_budget_reached: '引き継ぎホップ上限に到達',
      dev_commitment_unkept: 'スプリントのコミットメント未達',
      devWithheld: '保留',
      devRepetition: '繰り返し',
      devDeadAir: '未処理の引き継ぎ',
      devMeetingUnanswered: '返答なし',
      effectiveThresholdCol: 'しきい値',
      excessHopsLabel: '超過ホップ',
      timeTitle: 'サイクルタイムと生産性比較（AI処理 vs. 手作業）',
      timeSubtitle: '完了した開発タスクの実測AI処理時間と推定人手工数の比較。',
      timeHint: '工数見積もり用の基準参照値（経営陣により設定可能）。',
      avgCycle: '平均AIサイクル',
      fromTasks: '{n} 件のタスクから',
      speedup: '高速化',
      speedupHint: '1件あたり人間 {h} 時間と仮定',
      humanDelivered: '納品された人日',
      humanDays: '人日',
      forecast: '未完了作業の予測: {d} 人日',
      sizes: 'サイズ',
      sizeSmall: '小',
      sizeMedium: '中',
      sizeLarge: '大',
      scrumTitle: 'スクラム',
      scrumSubtitle: 'スプリント、ストーリーポイント、ベロシティ。会社自身のデータから',
      sprintLabel: 'スプリント {n}',
      ends: '終了',
      committedPts: 'コミットしたポイント',
      deliveredPts: '提供済みポイント',
      remainingPts: '残りポイント',
      burndownTitle: 'バーンダウン(日ごとの残りポイント)',
      velocityTitle: '終了したスプリントのベロシティ',
      predictability: '予測可能性',
      forecastLine: '移動ベロシティ {v} ポイント/スプリント · バックログ {b} ポイント ≈ {s} スプリント',
      noSprint: '実行中のスプリントはありません。次のプランニングで開始します。',
      noItems: 'まだ何もコミットされていません。スプリントは人が持ち込むものを受け取ります。',
      colItem: '項目',
      colOwner: '担当',
      colPoints: 'ポイント',
      colState: '状態',
      itemDone: '提供済み',
      itemOpen: '未完了',
      unestimated: '未見積り',
      addedBy: '{who} が追加',
      setGoal: 'スプリントゴール',
      sprintDaysLabel: 'スプリントの長さ(日)',
      save: '保存',
      endSprint: 'スプリントを今終了する',
      confirmEndSprint: 'スプリントを今終了しますか?レビュー、レトロスペクティブ、次のプランニングがすぐに行われます。',
      planNow: '最初のプランニングを今行う',
      confirmPlanNow: 'スプリントプランニングを今行いますか?pAIoneer-scrum で最初のスプリントを開始します。',
      sprintPointsCol: 'スプリントポイント',
      ceremonySpaceLabel: 'セレモニースペース',
      scrumOfScrums: 'Scrum of Scrums を今行う',
      confirmScrumOfScrums: 'pAIoneer-scrum で Scrum of Scrums を今行いますか?',
      lastScrumOfScrumsTitle: '前回の Scrum of Scrums',
      escalatedImpedimentsTitle: 'エスカレートされた障害（チーム横断）',
      unitBreakdownTitle: 'ユニット別内訳',
      colUnit: 'ユニット',
      colWip: '進行中の作業',
      colImpediments: '障害',
    },
    nav: {
      groups: {
        gametheory: 'チーム連携 & Scrum',
        demos: 'ライブプレビュー',
        sovereign: 'ソブリンLLM',
        today: '日次サマリー & 運用管制',
        organisation: '組織',
        work: '作業',
        communication: 'コミュニケーション',
        memory: '記憶',
        platform: 'プラットフォーム',
        products: '製品',
        identity: 'アイデンティティ',
      },
      pages: {
        gametheory: 'チーム連携 & Scrum',
        demos: 'ライブプレビュー',
        llm: 'LLMアーキテクチャ — 論文',
        training: 'データレイク & AIモデル学習',
        today: '日次サマリー & 運用管制',
        work: '作業項目とプロジェクト',
        coding: 'コーディング課題',
        gitlab: 'GitLab & イメージビルド',
        agents: 'エージェントと設計',
        research: '調査',
        webex: 'Webexスペース',
        mailboxes: 'メールボックス',
        conversations: '通話と会話',
        meetings: '会議',
        engines: 'AIエンジン & GPU',
        usage: '使用量と予算',
        workloads: 'コンテナサービス',
        orchestrator: 'Veridion MCPオーケストレーター',
      },
      sections: {
        demos: {
          previews: 'ライブプレビュー',
        },
        llm: {
          paper: '論文',
          monitoring: '監視',
        },
        training: {
          autopilot: "オートパイロット",
          storage: "クラウドストレージとフォルダツリー",
          acquisition: "データ収集と前処理",
          data: "データと知識グラフ",
          training: "学習と公開",
        },
        platform: {
          nodes: 'クラスタノード',
          events: 'イベント',
        },
        smtm: {
          runtime: 'ランタイム制御',
          prediction: '予測の制御',
          status: 'データの状態',
          reporting: 'シグナル',
          training: 'モデル',
          console: '学習コンソール',
        },
        agentic: {
          overview: '概要',
          tools: 'ツール',
          mcp: 'MCPサーバー',
          activity: 'アクティビティ',
        },
        'company-memory': {
          content: '内容',
          search: '検索と状況報告',
          facts: '事実',
          entity: 'エンティティ',
          remember: '記録',
          audit: '監査ログ',
          console: 'クエリコンソール',
          stores: 'ストア',
          graph: 'ナレッジグラフ',
          day: '一日',
            bubbles: '部門別知識ドメイン & 研究'
        },
        organisation: {
          chart: '組織図',
          colleagues: 'AI同僚とメールボックス',
          voices: '音声',
          people: '人とスペース',
          approvals: '承認とスケジュール',
          edit: '組織の編集',
        },
        work: {
          items: '作業項目',
          projects: '開発中のプロジェクト',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'イメージビルド',
        },
        agents: {
          agents: 'エージェント',
          designs: 'エージェント設計',
          definitions: '定義',
        },
        usage: {
          identities: 'アイデンティティ別',
          budgets: 'トークン予算',
          company: '会社インスタンス',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'ランタイム',
          mcp: 'MCPサーバー',
          tools: 'ツール',
          activity: 'アクティビティ',
        },
      },
      attentionTitle: '対応が必要',
      attentionSubtitle: 'すべての領域から、介入が必要な状態を表示します。クリックするとそのセクションが開きます。',
      attentionNone: '対応が必要な項目はありません。',
      stateTitle: '稼働状態',
      none: 'なし',
      readyOf: '{total}件中{ready}件が準備完了',
      connectedOf: '{total}件中{connected}件が接続済み',
      registeredOf: '{total}件中{registered}件が登録済み',
      showMore: 'さらに表示',
      shownOf: '{total}件中{shown}件',
      expand: '展開',
      collapse: '折りたたむ',
      service: 'サービス',
      serviceLinks: 'リンク',
      controlsTitle: 'Veridion Coreの制御',
      confirmRemove: '{what}を削除しますか？',
      companyIdentitiesTitle: '会社インスタンスのゲートウェイアイデンティティ',
      companyIdentitiesSubtitle: 'ゲートウェイの現在のウィンドウにおけるオーケストレーターとVeridion Coreのトークン。各アイデンティティとその予算。',
      conversationsTitle: 'ダッシュボードからの会話',
      conversationsSubtitle: 'AI同僚ごとのダッシュボードからの文書による会話。書く・通話するはページ上にダイアログを開きます。',
      conversationCount: 'メッセージ',
      conversationLastWritten: '最終送信',
      conversationLastAnswered: '最終回答',
      exchangesTitle: 'メッセージと回答',
      exchangesSubtitle: 'ダッシュボードからの各メッセージとAI同僚の回答。新しい順。',
      conversationMessage: 'メッセージ',
      conversationAnswer: '回答',
      today: {
        wordTitle: '有効な経営ディレクティブ',
        wordNone: '現在、有効な経営ディレクティブは設定されていません。',
        sinceTitle: '前回アクセス以降のイベント',
        sinceState: '{time}以降',
        workTitle: '進行中の課題と担当者',
        workNone: '進行中の作業項目はありません。',
        nextMeeting: '次回の会議',
        lastMeeting: '前回の会議',
      },
      work: {
        title: '作業項目',
        subtitle: '会社の記憶にある未完了の作業項目。担当者、状態、優先度、期限、シナリオの結果を含み、タイトルでグラフに開きます。',
        item: '作業項目',
        kind: '種類',
        owner: '担当者',
        status: '状態',
        priority: '優先度',
        due: '期限',
        scenarios: 'シナリオ',
        updated: '更新',
        none: '未完了の作業項目はありません。',
        all: 'すべての担当者',
      },
      meetings: {
        subtitle: 'Veridion Coreが記録するAI同僚の会議。時間枠、要約、作業となったコミットメント。',
        slot: '時間枠',
        kind: '種類',
        started: '開始',
        ended: '終了',
        summary: '要約',
        commitments: 'コミットメント',
        hold: '今すぐ会議を開く',
        held: '会議が招集されました。',
        notHeld: '会議が進行中か、直近30分以内に開催されました。',
        holdFailed: '会議を招集できませんでした',
        none: '記録された会議はまだありません。',
      },
      research: {
        title: '調査',
        subtitle: '会社のタイムラインに記録されたAI同僚の調査。新しい順。',
      },
      attention: {
        toneError: '障害',
        toneWarning: '注意',
        state: {
          platform: 'ワークロード{workloads}件中{ready}件が準備完了、ノード{total}件中{nodes}件が準備完了、再起動{restarts}回。',
          gateway: '{state}。モデル{models}件をルーティング、サービングバックエンド{total}件中{backends}件が準備完了。',
          engine: '{engine}：実行中{running}、待機中{waiting}',
          usage: 'ウィンドウ{window}で{identities}件のアイデンティティにより{tokens}トークン。',
          smtm: '予測ゲート{gate}、再構築{rebuild}。モデル{models}件中{online}件がオンライン、{failed}件が失敗。',
          smtmSignals: '未解決シグナル{open}件、解決済み{resolved}件、配信失敗{failed}件。',
          smtmVeridion: 'MCPサーバー{servers}件中{connected}件が接続済み。',
          company: 'オーケストレーター{status}。ワークロード{workloads}件中{ready}件が準備完了。Veridion Core {core}。エージェント実行中{agents}、待機中{waiting}。',
          companyWebex: 'ボットのWebhook {bots}件中{registered}件が登録済み。',
          approvals: '未処理の承認{approvals}件。人またはレビューを待つコーディングタスク{tasks}件。',
          sessions: 'サインイン中のユーザー{users}人、セッション{sessions}件、検証済み{mfa}件、アカウント{total}件。',
          mail: 'SMTP {state}。',
        },
        platformUnreadable: 'プラットフォームの状態を読み取れません。',
        nodeNotReady: 'ノード {name} は準備ができていません。',
        nodePressure: 'ノード {name} がリソース不足を報告しています: {pressure}。',
        workloadDown: '{name} ({namespace}): {desired} 中 {ready} が準備完了。',
        gatewayNotProgrammed: 'AIゲートウェイがプログラムされていません。',
        smtmGateClosed: '予測ゲートが閉じています。',
        smtmRebuild: '再構築がマークされています。',
        smtmHint: 'データの状態: {hint}。',
        smtmDeliveryFailed: 'シグナルの配信 {count} 件が失敗しました。',
        smtmModelsFailed: '{count} 個のモデルがエラーを報告しています。',
        mcpUnreachable: '{instance} の MCP サーバー {server} に到達できません。',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} が応答しません。',
        parts: {
          orchestrator: 'オーケストレーター',
          webex: 'Webexブリッジ',
          knowledge: 'ナレッジベース',
          core: 'Veridion Core',
          mcp: 'MCPサーバー',
          usage: '使用量台帳',
          gateway: 'ゲートウェイの使用量',
        },
        emergencyStop: 'Veridion Core の緊急停止が有効です。',
        coreMisconfigured: 'Veridion Core に設定が不足しています: {missing}。',
        agentsWaiting: '{count} 個のエージェントが回答を待っています。',
        hostedNotRunning: '{agent} は実行されていません。',
        webhookMissing: '{bot} の Webhook が登録されていません。',
        readerNotAuthorised: '会社のスペースの読み取りが許可されていません。',
        approvalOpen: '未処理の承認 ({position}): {question}',
        taskWaiting: '担当者を待つコーディングタスク: {title}',
        taskReview: 'レビュー可能なマージリクエスト: {title}',
      },
    },
    ops: {
      showDetails: '詳細',
      hideDetails: '閉じる',
      mcpVersion: 'バージョン',
      mcpUrl: 'アドレス',
      mcpProtocol: 'トランスポートとプロトコル',
      mcpLastRefresh: '最終問い合わせ',
      mcpError: 'エラー',
      noTools: '報告されたツールはありません。',
      toolServer: '提供元',
      toolAccess: 'アクセス',
      toolBuiltIn: 'Veridion',
      accessReadOnly: '読み取り',
      accessWrites: '書き込み',
      accessDestructive: 'データを変更',
      accessUndeclared: '未申告',
      usageTitle: '使用量',
      smtmUsageSubtitle: '過去30日間のモデル呼び出し、トークン、プロバイダーが報告したコスト。',
      usageByPerson: '人別',
      usageByModel: 'モデル別',
      usageByDay: '日別',
      model: 'モデル',
      day: '日',
      promptTokens: '入力トークン',
      completionTokens: '出力トークン',
      noUsage: '記録された使用量はありません。',
      runtimeTitle: 'ランタイム',
      runtimeSubtitle: 'このインスタンスのオーケストレーターがモデルにアクセスし、ツールを接続する方法。',
      executionMode: '実行',
      providerProtocol: 'モデルへのプロトコル',
      contextWindow: 'コンテキストウィンドウ',
      requestTimeout: 'リクエストごとのタイムアウト',
      diagnostics: '診断',
      diagnosticsOn: 'オン',
      diagnosticsOff: 'オフ（パフォーマンスモード）',
      externalServers: '接続中のMCPサーバー',
      mcpEndpoint: 'MCPエンドポイント',
      workloadsTitle: 'ワークロード',
      workloadsSubtitle: 'Kubernetes が報告する名前空間 paioneer-veridion のワークロード。',
      botsTitle: 'ボット',
      botsSubtitle: '組織のボットとそれぞれの Webhook、およびブリッジのサービス。',
      botAddress: 'アドレス',
      cardWebhook: 'カードの Webhook',
      webhookState: '状態',
      noBots: 'ブリッジはボットを報告していません。',
      bridgeServices: {
        knowledgeBase: 'ナレッジベース',
        webResearch: 'ウェブ調査',
        osint: 'OSINT',
        anonymizer: '匿名化',
      },
      connected: '接続済み',
      notConnected: '未接続',
      activeRooms: 'アクティブなルーム',
      allowedRooms: '許可されたルーム',
      surface: 'サーフェス',
      missingSettings: '不足している設定',
      none: 'なし',
      instanceToolsTitle: 'オーケストレーターのツール',
      instanceToolsSubtitle: '会社インスタンスのオーケストレーターが登録したツール。',
      openMailbox: 'メールボックス',
      positionMailboxHint: 'AIの同僚は他のAIの同僚からの引き継ぎを処理します。AIの同僚への依頼はその Webex スペースで行います。',
      mailboxesTitle: 'メールボックス',
      mailboxesSubtitle: 'エージェントごとに、メールボックスで待機中、配信済み、既読のものを表示します。行をクリックするとメッセージが絞り込まれます。',
      readAt: '取得時刻',
      refresh: '更新',
      mailbox: 'メールボックス',
      mailboxKind: '種類',
      mailboxKinds: {
        position: 'AIの同僚',
        hosted: 'ホスト型エージェント',
        graph: 'エージェント',
      },
      lastMessage: '最新のメッセージ',
      noMailboxes: '読み取れるメールボックスはありません。',
      messagesTitle: 'メッセージ',
      messagesSubtitle: 'メッセージ、コマンド、引き継ぎを新しい順に表示します。クリックすると全文が表示されます。',
      allMailboxes: 'すべてのメールボックス',
      allStates: 'すべての状態',
      time: '時刻',
      from: '送信元',
      to: '宛先',
      messageKind: '種類',
      content: '内容',
      reply: '返信',
      noMessages: 'メッセージはありません。',
      messageKinds: {
        message: 'メッセージ',
        handover: '引き継ぎ',
        command: 'コマンド',
        resume: '再開',
        subagent_result: 'サブエージェントの結果',
        review: 'レビュー',
      },
      buildsTitle: 'ビルド',
      buildsSubtitle: 'Veridion Core がエージェント用にビルドしたイメージ（新しい順）。',
      image: 'イメージ',
      started: '開始',
      finished: '完了',
      noBuilds: 'ビルドはありません。',
      coreToolsTitle: 'エージェントのツール',
      coreToolsSubtitle: 'Veridion Core がエージェントに提供するオーケストレーターのツール。',
      description: '説明',
      coreDailyTitle: '日別・モデル別の使用量',
      coreDailySubtitle: '過去30日間の Veridion Core のモデル呼び出し（エージェント別、モデル別）。',
      coreActivityTitle: 'Veridion Core のアクティビティ',
      coreActivitySubtitle: 'Veridion Core 内のエージェント、AIの同僚、引き継ぎのイベント（新しい順）。',
      event: 'イベント',
      tool: 'ツール',
      detail: '詳細',
    },
    tabCompanyMemory: '企業メモリ',
    llmPaper: {
      subtitle: 'ソブリン・モデルアーキテクチャの生成された学術的記述 — Veridion Core がアクティブな仕様に対して保持する論文ドキュメントから描画されます。',
      summaryTitle: 'このページが示すもの',
      summaryBody: 'Veridion Core はアクティブなモデルアーキテクチャに対して生成された学術ドキュメントを保持します。タイトル、概要、番号付きセクション、アーキテクチャ図、表、参考文献はバックエンドから変更なしに届き、設計値はそのように表示され、このページは何も創作しません。',
      refresh: '更新',
      exportPdf: 'PDFとして書き出す',
      strandTraining: '学習中',
      strandSelected: '選択済み',
      lcTitle: "実装とライフサイクル",
      lcSelectedTrains: "次に学習",
      lcCollectsOnly: "収集・準備のみ — 開始しない",
      lcSpec: "仕様",
      lcFrozen: "凍結中",
      lcArtifacts: "アーティファクト（トークナイザー／コーデック）",
      lcReleased: "リリース済み",
      lcNotReleased: "未構築",
      lcCodecOpen: "コーデック未完",
      lcData: "データしきい値",
      lcThresholdsMet: "達成",
      lcAreasReached: "データ計画: {total} 領域中 {met} 領域を達成",
      lcNoLake: "データレイク到達不可",
      lcStage_trainer_image: "トレーナーイメージ",
      lcStage_sealed_tdv: "TDV封印",
      lcStage_compat_all_green: "互換性 ALL-GREEN",
      lcStage_vram_budget: "VRAM予算",
      lcTraining: "学習",
      lcAuto: "しきい値達成で自動開始",
      lcBench: "ベンチマーク",
      lcBenchRows: "件の測定",
      lcNoneYet: "まだなし",
      lcRelease: "エクスポート · Hugging Face（非公開）· レジストリ",
      lcReleaseRows: "件",
      lcReleaseNote: "学習後：非公開確認付きアップロード＋レジストリ登録",
      lcPipeline: "学習パイプライン",
      lcDone: "完了",
      lcActive: "進行中",
      lcWaiting: "待機中",
      lcBlocked: "ブロック中",
      lcCapability: "能力",
      lcSamples: "サンプル",
      lcByLanguage: "言語別",
      lcForeign: '別の系統',
      lcCorpus: 'コーパスのトークン',
      lcCorpusNone: '未トークン化',
      loading: '読み込み中 …',
      unavailable: '論文ドキュメントに到達できません。',
      noPaper: 'この Veridion Core のバージョンはまだ論文ドキュメントを提供していません。そのため、このページは創作された内容を表示しません。',
      abstract: '概要',
      references: '参考文献',
      appendix: '付録',
      figure: '図',
      lastUpdated: '最終更新',
      empty: '項目はありません。',
    },
    llmMonitor: {
      summary: "モデルの運用監視: 状態、データ、GPU、カーネルとスループット、評価、イベント — Veridion Core とデータレイクから計測、作り話なし。",
      archTitle: 'アーキテクチャの状態',
      archSubtitle: "有効なアーキテクチャと、データインターフェースの状態および凍結状態。",
      version: 'バージョン',
      codename: 'コードネーム',
      statusLabel: 'ステータス',
      interfaceStatus: 'データインターフェース',
      specSha: '仕様ハッシュ(SHA-256、短縮)',
      promotedAt: '昇格日時',
      frozenLabel: '凍結',
      frozenYes: 'はい',
      frozenNo: 'いいえ',
      stateWord_active: "有効",
      stateWord_draft: "下書き",
      stateWord_released: "公開済み",
      stateWord_candidate: "候補",
      stateWord_retired: "終了",
      gpuModel: "グラフィックカード",
      gpuTotal: "グラフィックメモリ合計",
      gpuWindow: "学習枠（計測値）",
      gpuMeasuredAt: "計測日時",
      gpuSource: "計測元",
      gpuServing: "サービング",
      gpuInferenceTarget: "1枚での推論目標",
      vramTitle: 'GPUとVRAM予算',
      vramSubtitle: 'Veridion Coreが管理するグラフィックカードの測定済みVRAM予算。',
      vramNone: 'レコードにVRAM予算がありません。',
      gateTitle: '昇格ゲート',
      gateSubtitle: '候補アーキテクチャがアクティブなものを置き換えるためのポリシーと、必要なメトリクスおよびその重み。',
      metric: 'メトリクス',
      weight: '重み',
      gateNone: '必要なメトリクスが登録されていません。',
      candidatesTitle: '候補',
      candidatesNone: '候補アーキテクチャはありません。',
      evidenceTitle: '評価',
      evidenceNone: '測定された評価はまだありません。',
      benchmark: 'ベンチマーク',
      suite: 'スイート',
      score: 'スコア',
      evaluator: '評価者',
      date: '日付',
      changelogTitle: '変更履歴',
      changelogNone: '履歴にはまだアーキテクチャ版がありません。',
      summaryLabel: '概要',
      createdAt: '作成日時',
      supersededAt: '置換日時',
      eventsTitle: 'イベント',
      eventsNone: 'イベントは記録されていません。',
      implTitle: 'ストランドの実装状況',
      implSubtitle: "計測事実: データインターフェースの成果物、選択、トークンコーパス、ベクトルインデックス。領域ごとのデータ計画は状況に示します。",
      implSelected: '学習ストランド',
      implSelectedYes: '選択済み — 次に学習',
      implSelectedNo: '準備のみ（開始しない）',
      implTokenizer: 'トークナイザーのアーティファクト',
      implCodec: 'コーデックのアーティファクト',
      implNotReleased: '未リリース',
      implCapability: '能力',
      implSamples: 'サンプル（測定/目標）',
      implNoDatalake: 'サンプル進捗は現在読み取れません（データレイクのインターフェースに到達できません）。',
      implSwitchHint: '学習ストランドの選択はトレーニングページで切り替えます。',
      implSituationLink: "データの現状と学習に不足しているもの: 学習ページの状況",
      kernelTitle: 'カーネル高速化とスループット',
      kernelSubtitle: 'カーネルプローブがカード上で測定した内容: 各カーネルと参照実装の比較、アテンションのバックエンド、選択された仕様のスループット — そして測定したトークン数と測定したスループットから算出した時間計画。',
      kernelNone: 'このカードではまだカーネルプローブが実行されていません。何も仮定しません。',
      kernelName: 'カーネル',
      kernelVerified: '検証済み',
      kernelYes: 'はい',
      kernelNo: 'いいえ',
      kernelSpeedup: '高速化率',
      kernelMaxErr: '最大誤差',
      kernelError: '所見',
      kernelAttention: 'アテンションのバックエンド',
      kernelDocMask: '文書境界のマスキング',
      kernelThroughput: '測定スループット（トークン/秒）',
      kernelMicroBatch: 'マイクロバッチ',
      kernelMeasuredAt: '測定日時',
      kernelImage: 'トレーナーイメージ（ダイジェスト）',
      kernelRunPath: '最新実行のカーネル経路',
      kernelRunNone: 'カーネル情報を持つ学習実行はまだありません。',
      kernelPlanTitle: '時間計画（測定値に基づく計算）',
      kernelPlanTokens: 'トークン総量',
      kernelPlanTokensSource: 'トークン総量の出典',
      kernelPlanDays: '1 パスに要する予測日数',
      kernelPlanNone: '未測定 — 測定したスループットまたはトークン総量がない限り、時間計画は作りません。',
      kernelSourceTdv: '封印済み学習データ版',
      kernelSourceCorpus: 'これまでのコーパス（未封印）',
      kernelSourcePlan: "論文の予算",
      implForeign: '別の系統に属する',
      implIndex: 'ベクトル索引（グラフ連結）',
      implIndexNone: '索引の報告なし',
      implIndexDown: '設定済み、応答なし',
      implIndexPoints: 'ポイント',
      implIndexBackfillDone: '補充完了',
      implIndexBackfillOpen: '補充実行中',
      implIndexLink: 'レイク・モニターの索引と重複排除',
      implCorpus: 'トークンコーパス（生テキスト）',
    },
    software: {
      arch: {
        execTitle: "ソブリン・モデルアーキテクチャ",
        execSubtitle: "Veridion Core にあるただ一つのアクティブなアーキテクチャ仕様:すべての数値は、参照付きの計測成果物で裏付けられているか、バックエンドにより設計目標(未計測)と明示されています。",
        openDatalake: "Data Lake と AI モデル学習を開く",
        unavailableArch: "アーキテクチャのデータに到達できません。",
        frozen: "凍結中 — 学習実行がアクティブです",
        notFrozen: "承認済み(フェーズ A)",
        version: "バージョン",
        codename: "コードネーム",
        statusLabel: "状態",
        createdAt: "作成",
        promotedAt: "昇格",
        specSha: "仕様ハッシュ(SHA-256)",
        contextWindow: "コンテキスト窓(設計、トークン)",
        dataInterface: "データインターフェース",
        diStatus: {
          draft: "ドラフト",
          complete: "完全",
          missing: "欠落",
        },
        paramsTitle: "パラメータ収支",
        trainingVramTitle: "学習 VRAM(申告値、GB)",
        inferenceTitle: "推論 VRAM(申告値、GB)",
        declaredTotal: "申告合計",
        budgetTitle: "GPU VRAM 予算(計測)",
        budgetGpu: "GPU",
        budgetTotal: "総 VRAM(MiB)",
        budgetFreed: "空き学習予算(GB)",
        budgetInferenceTarget: "単一 GPU 推論目標(GB)",
        diagramTitle: "生成されたアーキテクチャ図",
        diagramSubtitle: "保存済みの仕様から決定的に生成されます。データの傍らに手書きの図は存在しません。",
        noDiagram: "応答に図が含まれていません。",
        stagesTitle: "アーキテクチャの段構成",
        stagesSubtitle: "保存済みの仕様から直接表示。パラメータの数値は設計値です。",
        stageCol: "段",
        layersCol: "レイヤー",
        mechanismCol: "メカニズム",
        paramsCol: "物理パラメータ(十億)と一次資料",
        paramsCross: "横断的 — 各段に計上済み",
        researchTitle: "量子・フロンティア AI 研究アーカイブ",
        researchSubtitle: "Veridion Core の研究アーカイブのライブ行。新しい文献は量子担当のツールを通じて追加され、それぞれの出所が見えます。",
        researchEmpty: "アーカイブに文献はまだありません。",
        evidenceTitle: "評価の証拠",
        evidenceSubtitle: "ここに表示されるのは計測済みで参照付きの評価のみ。証拠がなければスコアはありません。",
        evalMetric: "指標",
        evalBenchmark: "ベンチマーク",
        evalSuite: "スイート",
        evalScore: "値",
        evalEvaluator: "評価者",
        evalDate: "計測日",
        evalArtifact: "証拠成果物",
        gateTitle: "昇格規則(証拠ゲート)",
        gateMetrics: "必須指標",
        gateEpsilon: "許容差(イプシロン)",
        gateConfigVersion: "ゲート設定(バージョン)",
        candidatesTitle: "候補キュー",
        candidatesSubtitle: "提出されたアーキテクチャ候補とその証拠の充足状況。提出は研究ランタイム経由で行われ、ダッシュボードからは行われません。",
        candidateSubmittedBy: "提出者",
        candidateEvidence: "証拠(提出済み / 必要)",
        candidatesEmpty: "候補は提出されていません。",
        changelogTitle: "設計変更履歴",
        changelogSubtitle: "置き換えられた設計の反復 — 意図的に数値なし:それらについては一度も計測されていません。",
        changelogSummary: "概要",
        changelogEmpty: "置き換えられた設計はありません。",
        supersededAt: "置き換え日",
        eventsTitle: "ゲートイベント",
        eventsSubtitle: "ゲートが記録した提出・昇格・却下・凍結の遷移。",
        eventsEmpty: "イベントはまだありません。",
      },
      title: 'ソフトウェア開発',
      subtitle: 'コーディングエージェントのタスク、Azure DevOps から同期される社内 GitLab、レビュー待ちのマージリクエスト、そして GitLab ノードの上限。',
      openGitlab: 'GitLab を開く',
      openSonar: 'SonarQube を開く',
      loading: '読み込み中 …',
      failed: 'うまくいきませんでした',
      done: '完了',
      unavailable: '接続できません',
      capacityTitle: 'GitLab ノード',
      capacitySubtitle: 'ガードはサーバーの負荷から毎分ノードの上限を設定します。本番環境は常に予備を保持します。',
      stateLabel: '状態',
      memory: 'メモリ',
      cpu: 'CPU',
      disk: 'ディスク',
      hostFree: 'サーバーの空き',
      reserve: '本番用の予備',
      codingSlots: '同時に実行できるタスク',
      pipelineQuota: 'パイプラインのジョブ',
      recentActions: 'ガードの最近の操作',
      syncTitle: 'Azure DevOps からの同期',
      syncSubtitle: 'GitLab の master は Azure の master に追従します。GitLab だけにあったコミットはタグ replaced/<時刻> に残ります。',
      syncNow: '今すぐ同期',
      syncStarted: '同期を開始しました',
      azureCommit: 'Azure の master',
      gitlabCommit: 'GitLab の master',
      lastChange: '最後の変更',
      lastRun: '最後の実行',
      replaced: 'タグに保存',
      noneReplaced: 'なし',
      jobs: '最近の実行',
      error: 'エラー',
      readyTitle: 'レビュー可能なマージリクエスト',
      readySubtitle: 'パイプラインが成功したマージリクエストだけです。マージは GitLab で行います。',
      noReady: 'レビュー待ちのマージリクエストはありません。',
      tasksTitle: 'コーディングタスク',
      tasksSubtitle: 'コーディングエージェントのすべてのプログラミング作業と、その状態、マージリクエスト、トークン。',
      showFinished: '終了したタスクを表示',
      task: 'タスク',
      requester: '依頼者',
      statusLabel: '状態',
      mergeRequest: 'マージリクエスト',
      pipeline: 'パイプライン',
      tokens: 'トークン',
      updated: '更新',
      noTasks: 'まだコーディングタスクはありません。',
      phase: 'ステップ',
      repository: 'リポジトリ',
      branch: 'ブランチ',
      openQuestion: '未回答の質問',
      result: '結果',
      sendMessage: 'タスクに書き込む',
      answerQuestion: '質問に答える',
      urgent: '緊急：実行中のステップをすぐに誘導する',
      send: '送信',
      messageSent: 'タスクに届けました',
      confirmCancel: 'このタスクを中止しますか？開いているマージリクエストは閉じられます。',
      course: 'セッションの経過',
      messages: 'メッセージ',
      events: 'イベント',
      none: 'なし',
      close: '閉じる',
      newTitle: '新しいタスク',
      newSubtitle: 'ここからコーディングエージェントにタスクを渡せます。経過はここと Webex カードで確認できます。',
      brief: 'エージェントに何をしてほしいですか？',
      issue: 'YouTrack の課題（任意）',
      create: 'タスクを作成',
      created: 'タスクを作成しました',
      usersTitle: 'GitLab の管理者',
      usersSubtitle: 'すべての管理者は管理者権限付きの GitLab ユーザーを持ちます。ハウスキーピングが Keycloak と一致させます。',
      email: 'メール',
      gitlabUser: 'GitLab ユーザー',
      lastHousekeeping: '最後のハウスキーピング',
      sonarDeleted: '削除されたブランチの SonarQube プロジェクトを削除',
      previewsTitle: '開発中のプロジェクト',
      previewsSubtitle: '開発中の各プロジェクトは最初のマージから常にひとつだけ動きます。Veridion Core はメインブランチ（migration または master）の最新の緑の状態を管理者サインインの背後でコンテナとして起動し、緑のパイプラインごとに更新し、コンテナの起動・停止・再起動はここで行います。パイプラインが動くものを何も作らないプロジェクトは、その理由とともにここに表示されます。',
      previewsSummaryTitle: 'このビューが示すもの',
      previewsSummaryBody: '開発中の各プロジェクトは、管理者サインインの背後で独自のプレビューコンテナとして稼働します。上のリストは各プロジェクトの最新の実行可能な状態を、下の表は稼働中のコンテナを状態・アドレス・操作（開く、起動、停止、再起動）とともに示します。',
      previewProject: 'プロジェクト',
      previewState: '稼働中の状態',
      previewSince: '開始',
      previewAddress: 'アドレス',
      previewMergedAt: 'マージ',
      noPreviews: '動いているプロジェクトはありません。',
      reasonsLabel: 'ブロック原因と診断',
      noProjects: '開発中のプロジェクトはありません。',
      qualityCoverage: 'カバレッジ',
      qualityBugs: 'バグ',
      qualitySmells: 'コードスメル',
      qualityDuplication: '重複',
      qualityHotspots: '未確認ホットスポット',
      qualityUnavailable: 'SonarQube の測定値はありません',
      openPreview: '開く',
      startPreview: 'コンテナを起動',
      stopPreview: 'コンテナを停止',
      previewStarted: 'コンテナを起動しました',
      previewStopped: 'コンテナを停止しました',
      restartPreview: 'コンテナを再起動',
      previewRestarted: 'コンテナを再起動しました',
      previewControl: 'コンテナ',
      resultTitle: 'GitLab の結果',
      resultJobs: 'ジョブとアーティファクト',
      resultSonar: 'SonarQube',
      resultDelivered: '納品物',
      previewStatus: {
        starting: '開始中',
        running: '稼働中',
        stopped: '停止',
        failed: '失敗',
      },
      capacityStates: {
        ok: '上限内',
        tight: '逼迫：本番環境に余裕が必要',
        full: '満杯：新しい作業なし',
        node_down: 'ノードが停止中',
      },
      status: {
        queued: '空きを待っています',
        working: '作業中',
        waiting: '回答待ち',
        review: 'レビュー中',
        merged: 'GitLab でマージ済み',
        done: '完了',
        needs_person: '人の対応が必要',
        rejected: 'マージせずにクローズ',
        paused: '一時停止',
        cancelled: '中止',
        failed: '失敗',
      },
      commands: {
        pause: '一時停止',
        resume: '再開',
        cancel: '中止',
      },
      repositoryChoice: {
        auto: 'エージェントが決める',
        company: '{project}（人がマージ）',
        own: '{group} 内の独自のプロジェクト',
      },
      userState: {
        ok: '一致',
        created: '作成済み',
        unblocked: 'ブロック解除',
        'made administrator': '管理者に設定',
        blocked: 'ブロック',
      },
    },
    org: {
      write: '書く',
      call: "通話",
      callTitle: "{bot} との通話",
      writeTitle: '{bot}へのメッセージ',
      callConfirmEnd: '通話を終了しますか？',
      callSubtitle: '通話中はマイクが動作し続けます。ボットは自分の声で挨拶し、短く答え、不明な点があれば聞き返し、途中で割り込むこともできます。各文は Webex のボットとのダイレクトルームにも残ります。',
      callRinging: "呼び出し中 …",
      callConnected: "接続中",
      callEnded: "終了",
      callEndedHangup: "切りました",
      callEndedClosed: "接続が切れました",
      callEndedSilence: "90秒間の無音",
      callEndedLimit: "上限の30分に達しました",
      callEndedError: "エラーで通話が終了しました",
      callHangUp: "切る",
      callLevel: "マイクレベル",
      callYou: "あなた",
      callSpeaking: "ボットが話しています …",
      callThinking: '回答を生成しています …',
      callOvertaken: "次の質問に追い越されたため読み上げません",
      callNothingHeard: "言葉が聞き取れませんでした。",
      callMicDenied: "ブラウザーがマイクを拒否しました。このページでマイクを許可して、もう一度かけてください。",
      callNoVoice: "音声は現在利用できません。回答はテキストのままです。",
      callRefused: "通話は受け付けられませんでした。チケットが無効か期限切れです。もう一度かけてください。",
      callFailed: "通話に失敗しました",
      voice: "声",
      voiceHint: "この同僚が話す声。Webexで人が回答を聞きたいと求めたときと、電話で使われます。標準は OpenRouter の音声モデルの話者です。音声ストアの独自のクローン音声は、プラットフォームの音声エンジンで話します。",
      voiceSave: "声を保存",
      voiceDefault: "既定",
      voiceNone: "声なし",
      voiceCloud: "OpenRouter の話者（標準）",
      voiceOwn: "独自の声（クローン）",
      voiceUploadTitle: "この同僚の声のサンプルをアップロード",
      voiceUploadHint: "音声または動画、最大25 MB。Coreがサンプルを変換し、最大20秒を保持し、その言葉を聞き取り、参照クリップのみを保存します。同僚はすぐにこの声で話します。",
      voiceUploadName: "声の名前",
      voiceUploadConsent: "この声を会社で使う権利があることを確認します。自分の声であるか、本人が同意しています。",
      voiceUploadButton: "サンプルをアップロード",
      voiceUploadDone: "声を保存しました",
      voiceTooLarge: "ファイルが25 MBを超えています。",
      voicesTitle: "声",
      voicesSubtitle: "会社の各声はVeridion Coreの声ストアにある参照クリップです。ボットが話すたびに音声エンジンがそれをクローンします。以前の9人の話者はキャプチャしたクリップとして入っています。",
      voiceSeconds: "秒",
      voiceSource: "出所",
      voiceSourcePreset: "キャプチャした話者",
      voiceSourceUpload: "アップロードしたサンプル",
      voiceAddedBy: "追加者",
      voiceConsentBy: "同意の確認者",
      voiceWords: "クリップの言葉",
      voiceDelete: "削除",
      voiceConfirmDelete: "この声を削除しますか？これを使っている同僚は既定の声に戻ります。",
      voiceCapture: "プリセットエンジンの話者をキャプチャ",
      voiceCaptureHint: "話者ごとに固定の一文をプリセットエンジンで話し、クリップとして保存します。エンジン切り替えの前に実行します。",
      voiceCaptured: "キャプチャ済み",
      voiceEnginePresets: "音声エンジンは固定の話者を提供します。声ストアは使われません。",
      chartTitle: "組織図",
      executiveTitle: '経営層',
      unitsTitle: '事業部門',
      unitLead: '責任者',
      unitSupporting: '支援',
      unitMission: '使命',
      unitPrefix: 'スレッド接頭辞',
      standingActive: '稼働中',
      standingStandby: '待機',
      standbyOn: '待機にする',
      standbyOff: '稼働させる',
      standbyHint: '待機中の同僚は会社の自発的なターンを一切行わずトークンを消費しません。人からの直接のメッセージには引き続き応答します。',
      confirmStandby: '{name} を待機にしますか？',
      confirmActivate: '{name} を稼働させますか？',
      activity: '活動',
      runtime: '実行環境',
      modelCloud: 'クラウドモデル',
      modelGpu: '社内エンジン',
      callModel: '電話モデル',
      calls30: '通話、過去30日',
      telemetryLine: '{model} · {prompt}+{completion} トークン · {cost} · 耳 {asr} ms · 思考 {llm} ms · 声 {tts} ms · 合計 {total} ms{deferred}',
      telemetryDeferred: ' · 保留 {count} 件',
      chartSubtitle: "Veridion の AI 同僚: Veridion Core 内のエージェントで、それぞれ自身の Webex ボットとして連絡できます。領域ごとに並び、上に人間の意思決定者、下に専用ボットを持たないエージェントと会社スペースを、Veridion Core と Webex からライブで表示します。",
      chartPeople: "人間の意思決定者",
      chartPeopleText: "人間の意思決定者がすべてを決定し、{space} で行動します。",
      chartAgentsTitle: "専用ボットを持たないエージェント: コーディングエージェント、Veridion MCP オーケストレーター、アーキテクトが構築するエージェントは、AI 同僚に代わって働き、その同僚のボットを通して発言します",
      chartDesigned: "アーキテクトと設計したエージェント",
      chartFor: "依頼元",
      chartSystemsTitle: "接続されたシステム",
      chartSpaceHome: "ホームとする領域",
      chartSpacePurpose: "目的",
      chartRoomsTitle: "Webex の会社スペース",
      room: "スペース",
      roomBots: "ボット",
      positionsTitle: "AIの同僚",
      positionsSubtitle: "各AIの同僚は自分のボットで応答し、担当スペースを読みます。説明はそのAIの同僚が従う指示です。",
      bot: "ボット",
      position: "担当業務",
      statusLabel: "状態",
      tokensUsed: "使用トークン数",
      tokens30: "トークン（直近30日）",
      edit: "編集",
      close: "閉じる",
      description: "AIの同僚の説明",
      save: "保存",
      resetDescription: "既定の説明に戻す",
      interests: "関心プロファイル",
      interestsHint: "このAIの同僚に関係する項目の種類やテーマ、そして関係しない場合。AIの同僚はスペース内のすべてのメッセージをこれに照らして判断します。",
      threshold: '求められていない発言のしきい値',
      thresholdHint: '1から5：AIの同僚が求められずに発言するには、メッセージがどれだけ強く関係している必要があるか。1では関連が低くても発言し、5では関連が高い場合だけ発言します。',
      saveProfile: "プロファイルを保存",
      tools: "ツール",
      decisionMakersTitle: "意思決定者",
      decisionMakersSubtitle: "いずれの意思決定者も、Webexであらゆる承認を行い、AIの同僚からのあらゆる質問に答えられます。",
      email: "メールアドレス",
      add: "追加",
      remove: "削除",
      confirmRemove: "この意思決定者を削除しますか？",
      readerTitle: "会社スペースの閲覧",
      readerSubtitle: "ボットはメンションされたメッセージしか見えません。Veridionは、すべての会社スペースのメンバーであるアカウントの承認を通じて、各メッセージを読み取ります。",
      notConfigured: "連携が設定されていません",
      authorised: "承認済み",
      notAuthorised: "未承認",
      account: "アカウント",
      validUntil: "アクセストークンの有効期限",
      renewUntil: "承認の更新期限",
      authorise: "閲覧を承認",
      authoriseAgain: "再度承認",
      linkOpened: "Webexのサインインを新しいタブで開きました。",
      found: "検出",
      notFound: "未検出",
      botsInSpace: "ボット",
      transcripts: "会議の文字起こし",
      yes: "はい",
      no: "いいえ",
      approvalsTitle: "未回答の承認",
      approvalsSubtitle: "AIの同僚が依頼し、まだどの意思決定者も回答していない承認と質問。",
      originSpace: "スペース",
      directRoom: "ダイレクト会話",
      approvalKinds: { review: "承認", question: "質問" },
      schedulesTitle: "スケジュール",
      schedulesSubtitle: "スペースで依頼された定期作業。誰かが終了するまで実行されます。",
      createdBy: "依頼者",
      lastRun: "最終実行",
      end: "終了",
      confirmEnd: "このスケジュールを終了しますか？",
      none: "なし",
      loading: "読み込み中…",
      failed: "失敗",
      working: "処理中…",
      done: "完了",
      memoryTitle: "組織",
      memorySubtitle: "会社の人とAIの同僚、および各AIの同僚が働く記憶範囲。",
      memoryMember: "メンバー",
      area: "領域",
      decisionMaker: "意思決定者",
      status: { running: "稼働中" },
    },
    core: {
      conversationTitle: 'ダッシュボードからの会話',
      conversationHint: 'すべてのメッセージと回答は Webex でも伝えられます。エージェントの作業スレッドに、なければボットとのダイレクトルームに。',
      conversationEmpty: 'ダッシュボードからのメッセージはまだありません。',
      writeToAgent: 'このエージェントへのメッセージ',
      answerPending: '回答待ち',
      title: 'Veridion Core',
      subtitle: '企業ボットを支えるエージェント型オペレーティングシステムです。エージェント、そのメッセージとトークン使用量、定義、アーキテクト、組織を管理します。',
      done: '完了しました。',
      failed: '処理に失敗しました',
      loading: '読み込み中 …',
      working: '処理中 …',
      none: 'ありません。',
      unavailable: 'Veridion Core に接続できません',
      errors: {
        AGENT_FINISHED: 'エージェントは終了しており、これ以上メッセージを受け付けません',
        EMERGENCY_STOP: '緊急停止が有効です',
        DEFINITION_INVALID: '定義が有効ではありません',
        TOO_MANY_AGENTS: '実行中のエージェントが多すぎます',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core が設定されていません',
        MESSAGE_EMPTY: 'メッセージが空です',
      },
      status: {
        building: 'イメージをビルド中',
        starting: '起動中',
        running: '実行中',
        waiting: '待機中',
        idle: 'アイドル',
        paused: '一時停止中',
        completed: '完了',
        failed: '失敗',
        cancelled: '中止',
        stopped: '停止',
        not_deployed: '未デプロイ',
      },
      statusLabel: 'ステータス',
      owner: '所有者',
      definition: '定義',
      parent: '親エージェント',
      tokens: 'トークン',
      progress: '進捗',
      close: '閉じる',
      openQuestion: '未回答の質問',
      result: '結果',
      answerQuestion: '質問に回答',
      sendMessage: 'エージェントへのメッセージ',
      urgent: '緊急：現在のステップを中断する',
      send: '送信',
      messageSent: 'エージェントに配信しました。',
      commands: {
        pause: '一時停止',
        resume: '再開',
        cancel: '中止',
        kill: '強制終了',
      },
      confirmKill: 'このエージェントとそのサブエージェントを直ちに強制終了しますか？',
      subAgents: 'サブエージェント',
      graph: 'グラフ',
      messages: 'メッセージ',
      messageStatus: {
        queued: 'キュー待ち',
        delivered: '配信済み',
        consumed: '既読',
        refused: '拒否',
      },
      events: 'イベント',
      containerLog: 'コンテナログ',
      version: 'バージョン',
      activeAgents: '実行中のエージェント',
      updated: '更新日時',
      archived: 'アーカイブ済み',
      noDefinitions: '定義はまだありません。',
      versions: 'バージョン',
      from: '元',
      startInput: '開始入力（JSON）',
      agentStarted: 'エージェントを起動しました。',
      startAgent: 'エージェントを起動',
      editAsJson: 'JSON として編集',
      confirmArchive: 'この定義をアーカイブしますか？実行中のエージェントはそのまま動作を続けます。',
      archive: 'アーカイブ',
      definitionJson: '定義（JSON）',
      definitionJsonHint: 'Veridion グラフ言語による定義です。検証すると問題点とグラフが表示され、保存すると承認済みの新しいバージョンとして格納されます。',
      checked: '確認しました。',
      validate: '検証',
      saved: '新しいバージョンとして保存しました。',
      saveVersion: '新しいバージョンとして保存',
      valid: '定義は有効です。',
      you: 'あなた',
      architect: 'アーキテクト',
      architectPlaceholder: 'エージェントに実行させたい内容を記述してください …',
      newDesign: '新しい設計',
      unitKinds: {
        company: '会社',
        department: '部門',
        team: 'チーム',
        project: 'プロジェクト',
      },
      partOf: '所属先',
      confirmRemove: 'このユニットを削除しますか？メンバーはこのスコープを失います。',
      remove: '削除',
      addUnit: 'ユニットを追加',
      unitId: 'ID（小文字、ハイフン）',
      unitName: '名前',
      add: '追加',
      addMember: 'メンバーを追加',
      memberKinds: {
        person: '個人（メールアドレス）',
        agent: 'エージェント（ID）',
        definition: '定義（ID）',
      },
      memberId: 'メールアドレスまたは ID',
      role: 'ロール',
      confirmEmergencyOn: 'すべてのエージェントを今すぐ停止しますか？ボットは引き続き応答します。',
      confirmEmergencyOff: '緊急停止を解除しますか？',
      emergencyStop: '緊急停止',
      emergencyRelease: '緊急停止を解除',
      emergencyActive: '緊急停止が有効です',
      autopilotOn: 'オートパイロットを入にする',
      autopilotOff: 'オートパイロットを切にする',
      autopilotActive: 'オートパイロットが有効です。Veridion Core が人向けのすべてのカードに自ら回答します',
      autopilotUnitsTitle: '事業部別のオートパイロット',
      autopilotUnitsHint: '各事業部およびエグゼクティブ層ごとにオートパイロットを個別にオン・オフします。保留中の作業には一切触れられません。',
      autopilotUnitOn: 'オートパイロット ON',
      autopilotUnitOff: 'オートパイロット OFF',
      limitsBuilds: '同僚・1日あたりのイメージビルド数',
      limitsDesigns: '同僚・1日あたりのエージェント設計数',
      limitsSave: '日次上限を設定',
      limitsNone: '0 = 制限なし',
      confirmAutopilotOn: 'オートパイロットを入にしますか？Veridion Core 自身の意思決定者が pAIoneer-humans-and-bots のすべての未回答カードと新しいカードに直ちに回答し、カードのスレッドに表示されます。',
      confirmAutopilotOff: 'オートパイロットを切にしますか？以降は再び人が決定します。',
      model: 'モデル',
      codingModel: 'コーディングモデル',
      modelsTitle: '役割別モデル',
      modelsSubtitle: 'Veridion Core の各役割がどのモデルで考えるか：会社の顔と舵取り、電話、アーキテクト、要件判定の審判。ゲートウェイがルーティングするモデルのみ選択できます。空欄は設定の既定値を意味します。',
      roleCoordinator: 'コーディネーター（顔と舵取り）',
      roleCall: '電話',
      roleArchitect: 'アーキテクト',
      roleRequirementsJudge: '要件審判',
      roleJudge: 'Coreの判断',
      roleEar: '電話の耳',
      roleStt: 'Webexの耳',
      modelGroupVllm: 'vLLM（自前のカード）',
      modelGroupAudio: '音声（自前のカード／クラウド）',
      modelGroupCloud: 'OpenRouter（クラウド）',
      directLlmTitle: 'LLM への直接アクセス',
      directLlmSubtitle: 'ボットやエージェント、Webex を介さず、vLLM やクラウドモデルと直接対話',
      directLlmHint: '管理者の直接アクセス：選んだモデルが生で応答し、「console」として記録、レーンや役割、ツールなし。',
      directLlmModel: 'モデル',
      directLlmSystem: 'システムプロンプト（任意）',
      directLlmSystemPlaceholder: '例：あなたは …',
      directLlmPrompt: 'メッセージ',
      directLlmPromptPlaceholder: 'モデルに直接何を尋ねますか？',
      directLlmSend: '送信',
      directLlmSending: '送信中 …',
      directLlmUsage: '{prompt}+{completion} トークン · {cost}',
      modelCurrent: '使用中',
      modelDefault: '既定',
      modelChosen: '選択',
      modelDefaultOption: '設定の既定値',
      modelNotRouted: 'ゲートウェイ未ルーティング',
      modelSave: '保存',
      engineSilver: '社内エンジン（シルバー）',
      engineGold: '社内エンジン（ゴールド、オーケストレーター専用）',
      callsTitle: '電話通話',
      callsSubtitle: '電話の発話ターンごとに、同僚の作業とは別に計上：トークン、費用、耳・思考・声にかかった時間を、同僚とモデルごとに、過去30日と本日について。下に最新のターン。',
      callsTurns: 'ターン',
      callsCalls: '通話',
      callsAvgTotal: 'Ø 合計 ms',
      callsAvgAsr: 'Ø 耳 ms',
      callsAvgLlm: 'Ø 思考 ms',
      callsAvgTts: 'Ø 声 ms',
      callsDeferred: '保留',
      callsToday: '本日',
      callsWindow: '過去30日',
      callsRecent: '最新のターン',
      callsPerson: '人',
      callsRounds: 'ラウンド',
      callsNone: 'まだ通話は計上されていません。',
      unitKindExecutive: '経営層',
      unitKindBusinessUnit: '事業部門',
      orgSynced: '経営層と事業部門は Veridion Core の組織で定義され、ここに同期されています。変更はそちらで行い、このページでは行いません。',
      memory: 'メモリ',
      ready: '準備完了',
      notReady: '準備未完了',
      factExtraction: 'ファクト抽出が有効',
      cluster: 'クラスターへのアクセス',
      agentsRunning: '実行中のエージェント',
      agentsWaiting: '待機中',
      definitions: '定義',
      gatewayIdentity: 'ゲートウェイ ID',
      gatewayTokens: '時間枠内のゲートウェイトークン',
      hostedTitle: 'ホスト型エージェント',
      hostedSubtitle: 'Veridion Core が専用のコンテナで起動・運用する AI アプリケーションです。',
      agent: 'エージェント',
      actions: '操作',
      confirmHosted: '{action}：{agent}？',
      hostedActions: {
        start: '起動',
        stop: '停止',
        restart: '再起動',
      },
      open: '開く',
      agentsTitle: 'エージェント',
      agentsSubtitle: '各エージェントとサブエージェントは専用のコンテナで実行されます。エージェントを開くと、メッセージの送信や操作ができます。',
      showFinished: '終了したエージェントを表示',
      noAgents: 'エージェントはありません。',
      definitionsTitle: '定義',
      definitionsSubtitle: '承認済みのエージェントグラフとそのバージョンです。',
      designsTitle: 'エージェントの設計',
      designsSubtitle: 'アーキテクトが人またはAIの同僚の業務のために設計したすべてのエージェント：目的と理由、各質問と回答、シナリオに対するテスト実行、承認、実行。',
      design: '設計',
      designFor: '依頼元',
      designWork: '業務',
      designState: '状態',
      designApprovedBy: '承認者',
      designAgent: '作成されたエージェント',
      filterState: '状態',
      filterAll: 'すべて',
      filterOpen: '未完了',
      filterDone: '完了',
      filterFailed: '失敗',
      filterCurrent: '稼働中と最近の失敗',
      filterActive: '稼働中',
      filterFinished: '終了',
      filterPosition: 'AIの同僚',
      pagePrev: '前へ',
      pageNext: '次へ',
      pageLabel: 'ページ',
      searchLabel: '検索',
      showMore: 'さらに表示',
      noDesigns: '設計されたエージェントはまだありません。',
      designReason: 'ツールで足りなかった理由',
      designRecord: '記録',
      designAgents: '設計のエージェント',
      designTestRun: 'テスト実行',
      designRun: '実行',
      designStatus: { designing: '設計中', testing: 'テスト中', asking: '回答待ち', approval: '承認待ち', running: '実行中', done: '完了', failed: '失敗', cancelled: '中止' },
      builtBy: '作成者',
      builtFor: '対象業務',
      viaCodingTask: 'コーディングエージェント経由',
      designTests: 'テスト実行',
      designRuns: '実行',
      designByPerson: '会話中の人',
      diagramsTitle: '図',
      diagramsSubtitle: 'AIの同僚、エージェント、コーディングエージェントが描いたフロー、アーキテクチャ、計画の図（タイトル、凡例、Mermaidコード付き）。',
      noDiagrams: '図はまだありません。',
      diagramAuthor: '作成者',
      diagramBasedOn: '拡張元',
      diagramCode: 'Mermaidコード',
      architectTitle: 'アーキテクト',
      architectSubtitle: '対話形式でエージェントを設計します。アーキテクトは自ら判断できない点を質問し、承認を得てからエージェントを作成します。',
      orgTitle: '組織',
      orgSubtitle: '部門、チーム、プロジェクトとそのメンバーです。企業メモリはこの構造に沿って共有されます。',
      usageTitle: 'エージェント別の使用量',
      usageSubtitle: '過去 30 日間のモデル呼び出し、トークン、報告されたコストです。',
      calls: '呼び出し',
      source: '提供元',
      gpuTokens: 'GPUのトークン',
      cloudTokens: 'クラウドのトークン',
      usageByModel: '同僚とモデル別',
      cost: 'コスト',
    },
    memory: {
      archOverviewTitle: "アーキテクチャ概観:会社の記憶の構造",
      archOverviewText: "Veridion Core は会社の知識を三層で保存します:事実・決定・作業パッケージのための時間付きナレッジグラフとしての Neo4j、エージェント・メールボックス・スプリントのトランザクション状態のための PostgreSQL、そして社内文書のベクトル検索のための Qdrant。各ビジネスユニットは専門的に分離された知識ドメインで働き、ユニット間の成果は記録された引き継ぎを通じてのみ共有されます。",
      clustersTitle: "ビジネスユニットの知識ドメイン",
      clustersSubtitle: "各ビジネスユニットは区切られた Neo4j 知識ドメインで働きます。ノードとエッジの数は Neo4j からのライブ値で、説明は明示された初期投入に由来します。クリックでドメインをナレッジグラフに開きます。",
      clusterCode: "コード",
      clusterName: "知識ドメイン",
      clusterId: "識別子",
      clusterRoles: "担当ロール",
      clusterBridges: "引き継ぎブリッジ",
      clusterPolicy: "専門領域と分離ポリシー",
      clusterCounts: "ノード / エッジ(ライブ)",
      clusterInsights: "知見(初期投入)",
      clusterOpenButton: "ナレッジグラフで開く",
      countsUnavailable: "Neo4j に到達できません — 集計なし",
      researchTitle: "量子・フロンティア AI 研究アーカイブ",
      researchSubtitle: "基盤となる科学文献とアーキテクチャ参照 — Veridion Core からのライブ行。各行の出所が見えます。",
      researchEmpty: "アーカイブに文献はまだありません。",
      researchIngestNote: "新しい文献は量子担当がツールで追加します。ダッシュボードはアーカイブを読むだけです。",
      researchPublication: "文献",
      researchMechanism: "中核メカニズム",
      researchRelevance: "アーキテクチャとの関連",
      researchOrigin: "出所",
      researchSeeded: "初期投入",
      researchMotivates: "根拠となるバージョン",
      title: '企業メモリ',
      subtitle: 'Veridion Core が Neo4j に保持する内容です。スコープ別の記憶、有効期間付きのファクト、エージェントの実行内容の監査記録を確認できます。',
      failed: '処理に失敗しました',
      loading: '読み込み中 …',
      unavailable: 'メモリに接続できません',
      database: 'データベース',
      ready: '準備完了',
      notReady: '準備未完了',
      factExtraction: 'ファクト抽出',
      episodesQueued: '待機中のエピソード',
      lastError: '最後のエラー',
      contentTitle: '内容',
      contentSubtitle: 'ラベル別のノード数と、スコープ・種類別の記憶数です。',
      label: 'ラベル',
      count: '件数',
      empty: 'まだありません。',
      scope: 'スコープ',
      kind: '種類',
      kinds: {
        fact: 'ファクト',
        decision: '決定事項',
        task: 'タスク',
        procedure: '手順',
        note: 'メモ',
        episode: 'エピソード',
      },
      searchTitle: '検索',
      searchSubtitle: 'エージェントが使用する想起機能です。意味、単語、抽出されたファクトで検索します。',
      searchPlaceholder: '検索語または質問',
      allScopes: 'すべてのスコープ',
      search: '検索',
      noResults: '見つかりませんでした。',
      text: 'テキスト',
      validFrom: '有効開始日',
      source: 'ソース',
      extracted: '抽出',
      recorded: '記録',
      rememberTitle: '記憶する',
      rememberSubtitle: 'ファクト、決定事項、タスク、手順、メモをスコープに保存します。',
      remembered: '保存しました。',
      remember: '記憶する',
      created: '作成日時',
      validity: '有効性',
      invalid: '無効',
      confirmInvalidate: 'この記憶を無効としてマークしますか？',
      invalidate: '無効にする',
      forget: '忘れる',
      confirmForget: 'この項目を完全に忘れますか？記憶から削除され、元に戻せません。',
      forgotten: '忘れました。',
      factsTitle: 'ファクトの推移',
      factsSubtitle: '会話とエージェントの結果から抽出されたファクトです。矛盾が判明したファクトには終了日が設定されます。',
      noFacts: '抽出されたファクトはまだありません。',
      briefsTitle: 'AIの同僚ごとの概況',
      briefsSubtitle: '各AIの同僚が最初に読むもの：未完了の約束、有効な決定、進行中の案件、顧客。毎晩、記憶から作成されます。',
      brief: '概況',
      updated: '更新日時',
      noBriefs: 'まだ概況は作成されていません。',
      fact: 'ファクト',
      from: '起点',
      to: '終点',
      validUntil: '有効期限',
      stillValid: '現在も有効',
      entityTitle: '関連ノード',
      entitySubtitle: 'タスク、プロジェクト、人物、システム、エンティティが何と関連しているかを表示します。',
      entityPlaceholder: '名前、タスク ID、メールアドレスまたは ID',
      show: '表示',
      auditTitle: '監査',
      auditSubtitle: 'エージェントによるモデル呼び出し、ツール呼び出し、メッセージ、サブエージェントの起動です。',
      auditPlaceholder: 'エージェント ID（空欄：すべて）',
      filter: '絞り込み',
      time: '時刻',
      agent: 'エージェント',
      event: 'イベント',
      toolOrModel: 'ツールまたはモデル',
      status: 'ステータス',
      detail: '詳細',
      consoleTitle: 'クエリコンソール',
      consoleSubtitle: '読み取り専用の Cypher です。書き込みを行うステートメントは拒否されます。',
      run: '実行',
      truncated: '以降の行は省略されました',
      graph: {
        clusterPickTitle: "知識ドメインをグラフでフォーカス",
        clusterPickHint: "ビジネスユニットをクリックすると、その部分グラフがロールと引き継ぎブリッジとともにインタラクティブグラフでフォーカスされます。",
        allClusters: "全ドメイン(グラフ全体)",
        activeCluster: "アクティブな知識ドメイン",
        publicationsTitle: "研究アーカイブの文献",
        storesTitle: '会社メモリのストア',
        storesSubtitle: '企業メモリの各ストアが保持する内容をライブで読み取ります。Neo4jのグラフ、PostgresのVeridion Coreの状態、Qdrantのナレッジベースのベクトル。',
        storeNeo4j: 'Neo4j（グラフ）',
        storeNeo4jHolds: '企業メモリ：スコープ付きの記憶、Graphitiが抽出したエンティティと有効期間付きの事実、意味を持つ作業項目、ソフトウェア作業、エージェントの監査。',
        storePostgres: 'Postgres（リレーショナル）',
        storePostgresHolds: 'Veridion Coreのトランザクション状態：エージェントのプロセステーブル、メールボックス、会話、チェックポイント、コーディングタスク、承認、組織、使用量。',
        storeQdrant: 'Qdrant（ベクトル）',
        storeQdrantHolds: '企業ナレッジベース：管理者が追加した文書の埋め込み済み段落。会話ターンがナレッジベースを必要とするときにオーケストレーターが検索します。',
        nodes: 'ノード',
        relationships: 'リレーション',
        relationshipType: 'リレーション種別',
        tables: 'テーブル',
        table: 'テーブル',
        rows: '行',
        purpose: '保持する内容',
        documents: '文書',
        session: 'セッション',
        collection: 'コレクション',
        role: '役割',
        roleDocuments: '文書',
        roleCurated: '厳選された質問と回答の組',
        title: 'グラフ',
        subtitle: 'Neo4j 上の会社メモリのグラフ。検索結果、最新の記憶、または作業項目から始め、ノードをクリックして読み、隣接ノードを展開し、ドラッグで配置、スクロールでズームします。',
        startNewest: '最新の記憶',
        startWork: '作業項目',
        searchPlaceholder: 'グラフで探す名前、テキスト、またはID',
        find: '検索',
        noHits: '見つかりませんでした。',
        name: '名前',
        sources: { memory: '記憶', entity: '抽出されたエンティティ', node: 'プロジェクトメモリ', episode: 'エピソード' },
        show: '表示',
        shown: 'グラフ内のノード {nodes} 件、リレーション {edges} 件',
        truncated: '上限で切り詰められました。ノードを展開するか、検索を絞り込んでください',
        selected: '選択中のノード',
        selectHint: 'グラフのノードをクリックしてください。',
        expand: '隣接ノードを展開',
        expandTwo: '2階層まで展開',
        centre: 'このノードを中心にする',
        facts: 'このエンティティの事実',
        degree: 'リレーション',
        direction: '方向',
        out: '発信',
        in: '受信',
        noRelationships: 'リレーションはありません。',
        property: 'プロパティ',
        value: '値',
        noProperties: 'プロパティはありません。',
        factsOf: '事実：',
        factsSubtitle: 'Graphitiがこのエンティティについて抽出した内容と各事実の有効期間。否定された事実には終了日が付きます。',
        relation: '関係',
        other: '相手のエンティティ',
        newestTitle: '最新の記憶',
        newestSubtitle: '最後に書き込まれた記憶とその対象。「表示」でリンクとともに描画します。',
        about: '対象',
        workTitle: '作業項目',
        workSubtitle: '確定済みの各作業の状態、担当、課題、シナリオの結果。「表示」で意味、課題、コーディングタスク、そのために構築されたエージェントとともに描画します。',
        allStates: 'すべての状態',
        states: { confirmed: '確定', in_progress: '進行中', blocked: 'ブロック中', done: '完了', failed: '失敗', dropped: '取り下げ' },
        workItem: '作業項目',
        owner: '担当',
        issue: '課題',
        scenarios: 'シナリオ',
        results: { passed: '合格', failed: '不合格', pending: '未確定' },
      },
      day: {
        title: '会社の一日',
        subtitle: 'Veridion Core が記録するイベントのタイムライン：人の言葉、カード、作業、引き継ぎ、調査、エージェント、コーディングタスク、プロジェクト、障害、会議を新しい順に表示します。',
        sinceToday: '今日',
        sinceDay: '過去24時間',
        sinceWeek: '過去7日間',
        allKinds: 'すべての種類',
        refresh: '更新',
        count: '{n} 件のイベント',
        time: '時刻',
        actor: '実行者',
        happening: 'イベント',
        work: '作業',
        empty: 'この期間に記録はありません。',
        kinds: { word: '言葉', request: '依頼', card: 'カード', work: '作業', handover: '引き継ぎ', research: '調査', agent: 'エージェント', task: 'コーディングタスク', project: 'プロジェクト', incident: '障害', schedule: 'スケジュール', meeting: '会議', message: 'メッセージ' },
      },
    },
    title: '管理ダッシュボード',
    adminKicker: '運用',
    smtmStatusTitle: 'SMTM のデータと予測',
    smtmStatusSubtitle: 'ブローカーの時系列、公開済みモデル、予測出力、RSS フィードを監視します。',
    smtmStatusUnavailable: 'SMTM のステータスを取得できません',
    smtmGeneratedAt: '生成日時',
    smtmMinimumRows: '学習に必要な最小行数',
    smtmBaseFrames: '基礎時系列',
    smtmTrainableFrames: '生データ準備完了',
    smtmWaitingHistory: '履歴を待機中',
    smtmPredictionTrackedInstruments: '追跡中の銘柄',
    smtmPredictionEnabledCount: '予測が有効',
    smtmPredictionDisabledCount: '予測を停止中',
    smtmMlFrames: 'ML データセット',
    smtmOnlineModels: 'オンラインのモデル',
    smtmModelsWithArtifacts: '成果物を持つモデル',
    smtmPredictionFrames: '予測系列',
    smtmMissingPredictions: '予測のない系列',
    smtmBlobArtifacts: 'Blob 成果物',
    smtmStalePredictions: '古い予測',
    smtmRssFrames: 'RSS フィード',
    smtmDataframesTotal: 'データセット合計',
    smtmLatestModelUpload: '最新のモデルアップロード',
    smtmLatestPredictionWrite: '最新の予測書き込み',
    smtmRuntimeHints: '実行時の注意',
    smtmNoHints: '未解決の SMTM の注意はありません。',
    smtmInstrument: '銘柄',
    smtmBaseData: '基礎データ',
    smtmMlFrame: 'ML データセット',
    smtmModelPublish: 'モデルの状態',
    smtmArtifacts: '成果物',
    smtmPredictionFrame: '予測系列',
    smtmIssues: '問題',
    smtmNoIssues: '問題なし',
    smtmNoFrames: 'SMTM の銘柄が見つかりません。',
    smtmPredictionControlTitle: 'SMTM 予測制御',
    smtmPredictionControlSubtitle: '銘柄ごとに、SMTM が新しい機械学習予測を計算するか、基礎データの収集のみを続けるかを決めます。',
    smtmPredictionSettingsUnavailable: 'SMTM 予測制御を利用できません',
    smtmPredictionControlHint: '停止中の銘柄は履歴データを保持します。新しい ML データセット、学習、予測はもう生成されません。',
    smtmPredictionMode: '予測モード',
    smtmPredictionToggle: '管理者による制御',
    smtmPredictionToggleLabel: '予測を有効化または停止',
    smtmPredictionEnabled: '予測が有効',
    smtmPredictionDisabled: '予測を停止中',
    smtmPredictionSaving: '保存中...',
    smtmPredictionSettingsSaved: 'SMTM 予測制御を保存しました。',
    smtmPredictionSaveChanges: '変更を保存',
    smtmPredictionResetChanges: '変更を破棄',
    smtmPredictionPendingChanges: '件の未保存の変更',
    smtmPredictionPendingBadge: '保存待ち',
    smtmOpenAzuriteUi: 'Azurite の Web UI を開く',
    azuriteTitle: 'Azurite Web UI (SMTM)',
    azuriteSubtitle: 'modelstatus のエントリ、Blob 成果物、モデルのダウンロードを読み取り専用で表示します。',
    azuriteModelGroups: 'モデルグループ',
    azuriteBlobArtifacts: 'Blob 成果物',
    azuriteFiles: 'ファイル',
    azuriteSearchPlaceholder: 'モデルを絞り込む',
    azuriteNoModels: 'Azurite のモデルが見つかりません。',
    smtmRows: '行数',
    smtmLatest: '最新のタイムスタンプ',
    smtmAge: '経過',
    smtmValue: '値',
    smtmMinutesAgo: '分前',
    smtmMinutesAhead: '分後',
    smtmHoursAgo: '時間前',
    smtmDaysAgo: '日前',
    smtmStateLabels: {
      available: '利用可能',
      trainable: '学習可能',
      waiting_for_history: '履歴を待機中',
      missing_base_data: '基礎データなし',
      missing_machine_learning: 'ML データセットなし',
      missing_prediction: '予測なし',
      prediction_disabled: '予測を停止中',
      stale_prediction: '古い予測',
      open: '未処理',
      completed: '完了',
      online: 'オンライン',
      offline: 'オフライン',
      training: '学習中',
      uploading: 'アップロード中',
      failed: '失敗',
      unknown: '不明',
      missing: '欠落'
    },
    smtmIssueLabels: {
      empty_base_frame: '基礎時系列が空です',
      insufficient_history: '履歴が不足しています',
      missing_machine_learning_frame: 'ML データセットがありません',
      missing_prediction_frame: '予測系列がありません',
      stale_prediction_frame: '予測系列が古くなっています',
      missing_online_model: 'オンラインのモデルがありません',
      model_offline: 'モデルがオフラインです',
      missing_model_blob: 'モデルの Blob がありません',
      missing_model_header: 'モデルのヘッダーがありません',
      missing_modelstatus_entry: 'modelstatus のエントリがありません',
      inference_not_writing_prediction: '推論が予測を書き込んでいません',
      prediction_disabled_by_admin: '管理者が予測を停止しました'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: '準備完了なのに予測出力のない銘柄',
      instruments_waiting_for_history: 'まだ履歴を待っている銘柄',
      models_missing_artifacts: '成果物が揃っていないオンラインのモデル',
      no_online_models: 'Azurite にオンラインのモデルがありません',
      azurite_unavailable: 'Azurite ストレージの状態を現在取得できません'
    },
    mailTitle: 'メール設定',
    usersTitle: 'ユーザー管理',
    usersSubtitle: 'Keycloak のアカウント、ロール、状態、2FA。選択するとそのアカウントの操作が開きます。',
    usersHideCreate: 'フォームを閉じる',
    usersCreateHint: '新しいアカウントは 2FA 必須で始まり、設定が完了すると有効になります。',
    usersFilterAllStatus: 'すべての状態',
    usersFilterAllRoles: 'すべてのロール',
    usersManage: '管理',
    usersClose: '閉じる',
    usersNoneFound: 'ユーザーが見つかりません。',
    usersPagePrev: '前へ',
    usersPageNext: '次へ',
    auditTitle: '監査ログ',
    smtpHost: 'SMTP ホスト',
    smtpPort: 'SMTP ポート',
    smtpSecurity: 'SMTP のセキュリティ',
    smtpUsername: 'SMTP ユーザー',
    smtpPassword: 'SMTP パスワード',
    fromEmail: '送信元アドレス',
    fromName: '送信者名',
    replyToEmail: '返信先アドレス',
    saveMailSettings: 'メール設定を保存',
    sendTestMail: 'テストメールを送信',
    createUser: 'ユーザーを作成',
    setPassword: 'パスワードを設定',
    setRoles: 'ロールを設定',
    setStatus: '状態を設定',
    resetMfa: '2FA をリセット',
    revokeSessions: 'セッションを失効',
    filterUsers: 'ユーザーを絞り込む',
    testRecipient: 'テストメールの宛先',
    statusConfigured: '設定済み',
    statusMissing: '未設定',
    userEmail: 'メール',
    userName: 'ユーザー名',
    userRoles: 'ロール',
    userStatus: '状態',
    auditEvent: 'イベント',
    auditCreatedAt: '作成日時',
    auditDetails: '詳細',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'エンドポイント',
    aiGatewayIdentitySource: 'トークンのクレームによる識別',
    aiGatewayBudgetSource: '初期値の定義先',
    aiGatewayModels: 'ルーティング対象のモデル',
    aiGatewayModel: 'モデル',
    aiGatewayBackend: 'バックエンド',
    aiGatewayBudgets: 'トークン予算',
    aiGatewayIdentity: 'アイデンティティ',
    aiGatewayTokenBudget: 'トークン予算',
    aiGatewayWindow: 'ウィンドウ',
    aiGatewayAnyIdentity: 'すべてのアイデンティティ',
    aiGatewayAnyModel: 'すべてのモデル',
    aiUsageWindowStarted: 'ウィンドウ開始',
    aiUsageRemaining: '残り',
    aiUsageIdentities: 'アイデンティティ数',
    aiGatewaySubtitle: 'Envoy AI Gateway がモデルへの唯一の経路です。ルーティング対象のモデル、それを提供するバックエンド、各アイデンティティのトークン予算。',
    aiGatewayHint: '予算はここで運用します。デプロイ層は新しいクラスターの初期値を与えるだけです。',
    aiUsageTitle: 'アイデンティティ別の AI 使用量',
    aiUsageSubtitle: '現在のウィンドウでゲートウェイが計上したトークン数です。',
    sessionActiveUsers: 'ログイン中のユーザー',
    sessionActiveSessions: 'アクティブなセッション',
    sessionMfaSessions: '検証済みのセッション',
    aiUsageTotalTokens: 'トークン合計',
    aiServicesTitle: 'サービスアクセス',
    aiServicesSubtitle: 'プラットフォームの API と運用画面へのリンク。各リンク先が管理者ロールを自ら確認します。',
    aiMailSubtitle: 'Keycloak が確認メールとリセットメールを送信する SMTP 設定と、テスト送信。',
    tabOverview: '概要',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'メール配信',
    tabUsers: 'ユーザー',
    tabAudit: '監査ログ',
    tabServiceLinks: 'サービスアクセス',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'プラットフォーム',
    platformTitle: 'プラットフォームの状態',
    platformSubtitle: 'pAIoneer Labs GmbH の各ワークロードを、準備済みレプリカ・再起動回数・イメージとともに Kubernetes から直接表示します。',
    platformHostPage: 'アプリホストでインスタンスを管理',
    openVisitorMonitoring: '訪問者・マーケティング・SEO監視を開く',
    platformUnavailable: 'プラットフォームの状態を取得できません',
    platformWorkloadsTotal: 'ワークロード',
    platformDegradedTotal: '未準備',
    platformRestartsTotal: '再起動',
    platformWorkload: 'ワークロード',
    platformNamespace: '名前空間',
    platformReplicas: 'レプリカ',
    platformRestarts: '再起動',
    platformImage: 'イメージ',
    platformState: '状態',
    platformStateReady: '準備完了',
    platformStateDegraded: '劣化',
    platformStateDown: '停止',
    platformStateUnknown: '不明',
    platformNodes: 'ノード',
    platformOsImage: 'オペレーティングシステム',
    platformKernel: 'カーネル',
    platformRuntime: 'コンテナランタイム',
    platformKubelet: 'Kubelet',
    platformUsed: '現在の使用量',
    platformReportedCapacity: 'Kubernetes の報告値',
    platformConfiguredCap: '設定されたコンテナ上限',
    platformPressure: '逼迫状態',
    platformPressureNone: 'なし',
    platformCpu: 'CPU コア',
    platformNoWorkloads: 'この名前空間は設定オブジェクトのみを保持し、ワークロードはありません。',
    platformMemory: 'メモリ',
    platformEvents: '最近の警告',
    platformEventsNone: '警告はありません。',
    platformEventObject: '対象',
    platformEventReason: '理由',
    platformEventMessage: 'メッセージ',
    platformEventLastSeen: '最終検出',
    platformMetricsMissing: '使用量データがありません: metrics-server が応答していません。',
    aiGatewayBackends: '提供バックエンド',
    gpuTitle: 'GPU',
    gpuNote: 'GPU 上の各エンジンの負荷、アイデンティティ別および Webex ボット別に取得されたトークン、アイデンティティ別・エンジン別のトークン予算。',
    gpuTokensWindow: '時間枠内のGPUトークン',
    gpuSinceStart: 'エンジン起動以降',
    gpuIdentities: 'アイデンティティ別（現在の時間枠）',
    gpuBots: 'Webexボット・エージェント別（30日）',
    gpuBot: 'Webexボット / エージェント',
    gpuBudgetTitle: 'エンジンのアイデンティティ別予算',
    gpuBudgetSet: '予算を設定',
    gpuBudgetHint: 'エンジンでの1時間あたりのトークン数。ゲートウェイが適用します。制限のないアイデンティティにも上限を設けます。',
    gpuNoneYet: 'まだ記録はありません。',
    gpuEngines: 'エンジン',
    gpuEngine: 'エンジン',
    gpuEngineGold: 'ゴールドエンジン',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Agentic RAG アプリケーションの実行環境、ナレッジベース、学習準備、追跡可能性。',
    agenticRagBackendStatus: 'バックエンドの状態',
    agenticRagRuntimeMode: '実行モード',
    agenticRagKnowledgeMode: 'ナレッジモード',
    agenticRagDeploymentEnv: 'デプロイ環境',
    agenticRagVectorStores: 'ベクターストア',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'ドキュメントコレクション',
    agenticRagQdrantCuratedCollection: 'キュレーション済み質問応答コレクション',
    agenticRagQdrantDashboard: 'ダッシュボード',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Swagger を開く',
    agenticRagOpenPhoenix: 'Phoenix を開く',
    agenticRagOpenQdrant: 'Qdrant を開く',
    agenticRagKnowledgeTitle: 'ナレッジベース',
    agenticRagKnowledgeSubtitle: 'Agentic RAG アプリケーションのドキュメントとキュレーション済み質問応答の状態。',
    agenticRagDocuments: 'ドキュメント',
    agenticRagCuratedQaPairs: 'キュレーション済み質問応答ペア',
    agenticRagTrainingTitle: '学習準備',
    agenticRagTrainingSubtitle: '最新のジェネレーター実行とトレーナーの最新状態。',
    agenticRagLatestDataset: '最新のデータセット',
    agenticRagDatasetPairs: '質問応答ペア',
    agenticRagDatasetDocuments: '処理済みドキュメント',
    agenticRagDatasetModifiedAt: '最終更新',
    agenticRagLatestTrainerInput: '最新のトレーナー入力',
    agenticRagTrainerInputModifiedAt: '入力の更新',
    agenticRagLatestTrainerRun: '最新のトレーナー実行',
    agenticRagTrainerRunModifiedAt: '実行サマリーの更新',
    gpuEngineSilver: 'シルバーエンジン',
    gpuAssignment: '割り当て',
    gpuWho: '誰',
    gpuRank: '順位',
    gpuRankHint: '順位0が最初に処理されます。各エンジンは順位順に処理します。',
    gpuLanes: 'エンジン別・順位別の Veridion Core の実行中の呼び出し',
    gpuInFlight: '実行中',
    gpuWhoMainBotPeople: 'メインボット：人との会話',
    gpuWhoMainBotJudgements: 'メインボット：同じターンでの判定',
    gpuWhoAutopilot: 'オートパイロット',
    gpuWhoAgents: 'メインボットが実行するエージェント',
    gpuWhoArchitect: 'アーキテクト',
    gpuWhoChair: '会議の議長',
    gpuWhoOrchestrator: '会社インスタンスのオーケストレーター',
    gpuWhoColleagues: 'AI の同僚：ターンとその判定',
    gpuWhoMeetingWords: 'AI の同僚：会議での発言',
    gpuWhoBackgroundReading: 'バックグラウンドサービス：ボット投稿の読み取り',
    gpuWhoMemory: '企業メモリ：受け入れとブリーフ',
    gpuWhoCoding: 'コーディング課題：判定と学習',
    gpuWhoResearch: 'ウェブおよびOSINT調査',
    gpuWhoKnowledgeBase: '会社ナレッジベース：スキャンページの読み取り',
    gpuWhoPipeline: 'IDD に照らしたパイプラインレビュー',
    gpuWhoSmtm: 'Veridion SMTM：SaaS のチャットとナレッジベース、最後の順位',
    gpuUnavailable: 'GPUが応答しません',
    aiGatewaySource: '提供元',
    aiSourceGpu: 'GPU',
    aiGatewayMeter: 'カウンター',
    aiGatewayMeterIdentity: 'すべてのアイデンティティ（計測）',
    aiGatewayEngines: 'GPU上のエンジン',
    aiGatewayEnginesHint: '各エンジンのメトリクスから得たライブ指標：処理中および待機中のリクエスト、キャッシュ使用率、起動以降に処理したトークン数。',
    aiEngineRunning: '処理中',
    aiEngineWaiting: '待機中',
    aiEngineCache: 'キャッシュ使用率',
    aiEngineServed: '処理トークン',
    aiEngineIdle: 'リクエストなし',
    aiEngineUnavailable: 'エンジンが応答しません',
    aiGatewayServing: '準備完了',
    aiBudgetControlTitle: 'トークン予算の運用',
    aiBudgetControlSubtitle: '既定の予算はすべてのアイデンティティに適用されます。個別のアイデンティティには専用の上限を設定できます。',
    aiBudgetDefault: '既定の予算',
    aiBudgetIdentity: 'アイデンティティ',
    aiBudgetTokens: 'トークン',
    aiBudgetApply: '適用',
    aiBudgetAdd: '上限を設定',
    aiBudgetRemove: '削除',
    aiBudgetSaved: 'トークン予算を適用しました。',
    aiBudgetIdentityPlaceholder: 'クライアント ID (例: paioneer-agent-veridion-smtm)',
    aiBudgetUnlimited: '上限なし',
    aiBudgetSetUnlimited: '上限を解除',
    aiBudgetRestoreLimit: '上限を戻す',
    aiUsageReset: 'ウィンドウを消去',
    aiUsageResetDone: '現在のウィンドウを消去しました。',
    userMfa: '2FA',
    userMfaOn: '設定済み',
    userMfaOff: '未設定',
    userCreatedAt: '作成日',
    mailSource: '管理場所',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'トレーディングアシスタントの会話コア：ランタイム、ツールレジストリ、MCPサーバー、アクティビティ。',
    veridionOpenPage: 'Veridion を開く',
    veridionOpenDocs: 'Swagger を開く',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'ツール',
    veridionToolsTitle: 'ツールレジストリ',
    veridionToolsSubtitle: '読み込まれているツール群と実際の状態を表示します。',
    veridionToolName: 'ツール',
    veridionToolRuntime: 'ランタイム',
    veridionToolRisk: 'リスク',
    veridionToolEnabled: '有効',
    veridionNoTools: 'Veridion のツールは読み込まれていません。',
    veridionRuntimeProfiles: 'ランタイムプロファイル',
    veridionRegistryReloaded: 'レジストリを再読み込みしました',
    veridionProvider: 'AIパス',
    veridionMcpTitle: 'MCPサーバー',
    veridionMcpSubtitle: '接続された外部ツールサーバーの状態とツール数。',
    veridionMcpServer: 'サーバー',
    veridionMcpState: '状態',
    veridionMcpTools: 'ツール',
    veridionMcpLastSuccess: '最終接続',
    veridionMcpConnected: '接続済み',
    veridionMcpUnreachable: '到達不可',
    veridionMcpDisabled: '無効',
    veridionMcpEmpty: 'MCPサーバーは設定されていません。',
    veridionActivityTitle: 'アクティビティ',
    veridionActivitySubtitle: 'オーケストレーターとそのツールから得られる構造化された実行イベント。',
    veridionActivityEmpty: 'まだアクティビティは記録されていません。',
    veridionActivitySource: '発生元',
    veridionActivitySurface: 'サーフェス',
    veridionActivityEvent: 'イベント',
    veridionActivityTool: 'ツール',
    veridionActivityStatus: '状態',
    veridionActivitySummary: '要約',
    veridionUnavailable: 'Veridion は現在利用できません。',
    veridionNotConfigured: 'Veridion は Homepage ランタイムでまだ完全に設定されていません。',
    veridionRequestFailed: 'Veridion は要求された管理呼び出しを正常に完了できませんでした。',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'pAIoneer Labs GmbH の社員向け Webex 用 Veridion インスタンス。YouTrack と専用のナレッジベースを備え、モデル呼び出しは Envoy AI Gateway を経由します。',
    companyWorkloads: 'ワークロード',
    companyTokensWindow: '現在のウィンドウのトークン',
    companyBudget: '予算',
    companyBudgetDefault: '既定の予算',
    companyCost30: '過去30日間のコスト',
    openrouterTitle: 'OpenRouter の請求額',
    openrouterRemaining: '残りクレジット',
    openrouterOf: '/',
    openrouterToday: '今日',
    openrouterWeek: '今週',
    openrouterMonth: '今月',
    openrouterUnavailable: '現在 OpenRouter を読み取れません',
    openrouterNote: 'プラットフォームのキーに対する OpenRouter の請求額（米ドル、日と週は UTC）。下の記録値は費用を返した応答だけを数えるため、これより低くなります。',
    companyRequests30: '過去30日間のモデル呼び出し',
    companyCostNote: 'コストは OpenRouter がリクエストごとに報告する米ドル額です。トークンは Envoy AI Gateway が ID {identity} に計上します。',
    companyCostNotReported: '未報告',
    companyPartUnavailable: '到達不可',
    companyWebexTitle: 'Webex ボット',
    companyWebexSubtitle: 'Webex は webex.paioneer-labs.eu/hook を呼び出します。ブリッジが署名と送信者を確認し、許可されたメッセージだけを Veridion に渡します。',
    companyWebexBot: 'ボット',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: '登録済み',
    companyWebexNotRegistered: '未登録',
    companyWebexAccess: '許可',
    companyWebexAnswered: '回答済み',
    companyWebexRejected: '拒否',
    companyWebexFailed: '失敗',
    companyWebexRecent: '最近の配信',
    companyWebexTime: '時刻',
    companyWebexOutcome: '結果',
    companyWebexReason: '理由',
    companyWebexSender: '送信者',
    companyWebexEmpty: '前回の起動以降、配信はありません。',
    companyWebexNotConfigured: 'Webex ブリッジに到達できないか、管理 API にそのステータスキーがありません。',
    companyUsageTitle: 'ユーザー別の利用状況',
    companyUsageSubtitle: 'インスタンスの利用台帳に基づく過去30日間のモデル呼び出し、トークン、コスト。',
    companyUsagePerson: 'ユーザー',
    companyUsageCalls: '呼び出し',
    companyUsageTokens: 'トークン',
    companyUsageCost: 'コスト（USD）',
    companyUsageEmpty: '過去30日間にモデル呼び出しはありません。',
    companyWebexSendTitle: 'ボットとして送信',
    companyWebexSendPerson: '個人へ',
    companyWebexSendRoom: 'ボットのスペースへ',
    companyWebexSendEmail: 'Webex のメールアドレス',
    companyWebexSendText: 'メッセージ（Markdown）',
    companyWebexSendButton: '送信',
    companyWebexSendDone: '送信しました。',
    companyWebexSendFailed: '失敗しました',
    companyWebexRooms: 'ボットのスペース',
    companyWebexRoomGroup: 'グループ',
    companyWebexRoomDirect: 'ダイレクト',
    companyWebexRoomsEmpty: 'ボットはまだどのスペースにも参加していません。',
    companyKnowledgeTitle: 'ナレッジベース',
    companyKnowledgeSubtitle: '企業インスタンスのナレッジベース（Agentic RAG）の文書。会話のターンで必要になるとオーケストレーターが検索し、Phoenix が各検索を記録します。',
    companyKnowledgeDocument: '文書',
    companyKnowledgeSize: 'サイズ',
    companyKnowledgeModified: '追加日時',
    companyKnowledgeDelete: '削除',
    companyKnowledgeDeleteConfirm: '{name} をナレッジベースから削除しますか？',
    companyKnowledgeUpload: '文書を追加',
    companyKnowledgeUploading: 'アップロード中 …',
    companyKnowledgeIntake: '取り込み',
    companyKnowledgePhoenix: 'Explainable AI（Phoenix）',
    companyKnowledgeEmpty: 'ナレッジベースは空です。',
    companyKnowledgeNotConfigured: 'ナレッジベースが管理 API に接続されていません。',
    companyGuestsTitle: 'アクセスできるゲスト',
    companyGuestsHint: '{domains} のアドレスはすべてボットを利用できます。社外のアドレスは管理者がここで個別に追加し、変更はすぐに反映されます。',
    companyGuestsEmail: 'メールアドレス',
    companyGuestsAdd: '追加',
    companyGuestsRemove: '削除',
    companyGuestsRemoveConfirm: '{email} のボットへのアクセスを取り消しますか？',
    companyGuestsAddedBy: '追加者',
    companyGuestsAddedAt: '追加日時',
    companyGuestsEmpty: 'ゲストは登録されていません。',
    companyGuestsNotPersistent: 'リストは保存されません。ブリッジにデータディレクトリがありません。',
    companyGuestsLoadFailed: '保存されたリストを読み取れませんでした。次に変更するまで、どのゲストもアクセスできません。',
    companyErrorRecipientNotAllowed: 'このアドレスはボットに返信できません。先にゲストとして追加してから送信してください。',
    companyErrorDomainAllowed: 'このドメインのアドレスはすでにアクセスできます。',
    companyErrorInvalidEmail: '有効なメールアドレスではありません。',
    companyErrorAlreadyListed: 'このアドレスはすでにリストにあります。',
    companyErrorStoreUnwritable: 'リストを保存できませんでした。',
    smtmFilterTitle: 'SMTM 銘柄フィルター',
    smtmFilterSubtitle: '空欄にするとすべての銘柄を表示します。複数の銘柄名はカンマで区切ります。例：EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1',
    smtmFilterPlaceholder: '銘柄名をカンマ区切りで入力',
    smtmFilterApply: 'フィルターを適用',
    smtmFilterClear: 'フィルターを消去',
    smtmReportingTitle: 'SMTM シグナルレポート',
    smtmReportingSubtitle: '条件を満たした買いシグナル、その手仕舞い評価、自動通知の配信状況を表示します。',
    smtmReportingUnavailable: 'SMTM のレポートを利用できません',
    smtmReportingQualifiedSignals: '条件を満たしたシグナル',
    smtmReportingOpenSignals: '未決のシグナル',
    smtmReportingResolvedSignals: '決済済みのシグナル',
    smtmReportingWins: '勝ち',
    smtmReportingLosses: '負け',
    smtmReportingWinRate: '勝率',
    smtmReportingAverageActualReturn: '実績リターン平均',
    smtmReportingNetActualReturn: '実績リターン純額',
    smtmReportingDeliveryFailed: '配信失敗',
    smtmReportingEntryTime: 'エントリー時刻',
    smtmReportingExitTime: 'エグジット時刻',
    smtmReportingExpectedReturn: '期待リターン',
    smtmReportingActualReturn: '実績リターン',
    smtmReportingSignalStatus: 'シグナルの状態',
    smtmReportingNoSignals: '条件を満たしたシグナルはまだ保存されていません。',
    smtmReportingPendingDeliveries: '配信待ち',
    smtmReportingFailedDeliveries: '配信失敗',
    smtmReportingDeliveryError: '配信エラー',
    smtmTrainingTitle: 'SMTM の学習とモデル',
    smtmTrainingSubtitle: '学習品質、モデルの状態、学習サービスが公開した成果物を表示します。',
    smtmTrainingUnavailable: 'SMTM の学習情報を利用できません',
    smtmTrainingModels: 'モデル',
    smtmTrainingOnlineModels: 'オンラインのモデル',
    smtmTrainingFailedModels: '失敗したモデル',
    smtmTrainingStaleModels: '古いモデル',
    smtmTrainingAverageMae: 'MAE 平均',
    smtmTrainingAverageRmse: 'RMSE 平均',
    smtmTrainingAverageR2: 'R² 平均',
    smtmTrainingAverageMase: 'MASE 平均',
    smtmTrainingAverageHitRate: '方向的中率 平均',
    smtmTrainingHitRate: '方向的中率',
    smtmTrainingLastSuccess: '最後に成功した学習',
    smtmTrainingResolution: '解像度 / ホライズン',
    smtmTrainingConsoleTitle: 'SMTM 学習コンソール',
    smtmTrainingConsoleSubtitle: '学習サービスの出力をライブ表示します。',
    smtmTrainingConsoleUnavailable: 'SMTM 学習コンソールを利用できません',
    smtmTrainingConsoleEmpty: '学習の出力はまだありません。',
    smtmRuntimeTitle: 'SMTM ランタイム',
    smtmRuntimeSubtitle: '稼働中の SMTM システムの全体ホライズン、再構築状態、予測ゲート。',
    smtmRuntimeUnavailable: 'SMTM ランタイムを利用できません',
    smtmRuntimeForecastHorizon: '予測ホライズン',
    smtmRuntimeResolution: '解像度',
    smtmRuntimeConfigVersion: '設定バージョン',
    smtmRuntimePredictionGate: '予測ゲート',
    smtmRuntimeRebuild: '再構築',
    smtmRuntimeStateOpen: '開',
    smtmRuntimeStateClosed: '閉',
    smtmRuntimeStateActive: '実行中',
    smtmRuntimeStateIdle: '待機',
    smtmRuntimeForecastHorizonMinutes: '予測ホライズン (分)',
    smtmRuntimeResolutionMinutes: '解像度 (分)',
    smtmRuntimeRequireCompletedBars: '確定した足のみ使用',
    smtmRuntimePredictionGateOpen: '予測ゲートを開く',
    smtmRuntimeRebuildActive: '再構築を実行',
    smtmRuntimeSaving: 'ランタイムを保存中...',
    smtmRuntimeSave: 'ランタイム設定を保存',
    smtmRuntimeReset: 'ランタイムの変更を破棄',
    smtmRuntimeSaved: 'SMTM ランタイム設定を保存しました。',
    smtmTrainingRows: '学習 / テスト行数',
    smtmTrainingMetrics: '指標',
    smtmTrainingIssues: '学習の問題',
    smtmTrainingLlmFeatures: 'LLM 特徴量',
    smtmTrainingNoModels: 'キャッシュされた学習モデルはまだありません。',
    smtmDirection: '方向',
    smtmSentiment: 'センチメント',
    smtmDeliveryStage: '段階',
    smtmDeliveryRecipient: '宛先',
    mailSettingsSaved: 'メール設定を保存しました。',
    mailTestSent: 'テストメールを送信しました。',
    userCreatedSuccess: 'ユーザーを作成しました。',
    userUpdatedSuccess: 'ユーザーを更新しました。',
    userDeletedSuccess: 'ユーザーを削除しました。',
    deleteUser: 'ユーザーを削除',
    roleLabels: {
      admin: '管理者',
      pro: 'Pro',
      tester: 'テスター',
      user: 'ユーザー'
    },
    statusLabels: {
      pending_email_verification: 'メール確認待ち',
      pending_mfa: '2FA 設定待ち',
      active: '有効',
      locked: 'ロック中',
      disabled: '無効'
    }
  },
  footer: {
    managingDirectors: '代表取締役',
    servicesTitle: 'サービス',
    legal: { title: '法的情報', imprint: '法的表示', privacy: 'プライバシーポリシー', aiTransparency: 'AIの透明性', cookieSettings: 'Cookie設定', terms: '利用規約' },
    copyright: '無断複写・転載を禁じます。'
  },
  auth: {
    validating: '検証中...',
    errors: { registrationFailed: '登録に失敗しました: ', unknownError: '不明なエラー' }
  },
  account: {
    username: 'ユーザー名',
    email: 'メールアドレス',
    roles: 'ロール',
    manageText: 'パスワード、二要素認証、アクティブなセッション、メールアドレスはアカウント管理で変更できます。',
    manageButton: 'アカウント管理を開く',
    signedOut: 'ログインしていません。'
  },
  cookies: {
    title: 'プライバシー設定',
    description: '当社は、ウェブサイトの改善のため、機械学習の手法を用いて訪問統計を分析しています。同意いただいた場合、IPアドレスを含む利用データおよび端末データを処理し、次回以降の訪問時にお使いのブラウザを再認識します。同意は任意であり、「{settings}」からいつでも撤回できます。第三国への移転を含む詳細は、プライバシーポリシーをご覧ください。',
    necessary: {
      title: '必須',
      description: 'ウェブサイトの運用に必要なもの（言語の選択、この選択内容の保存など）。'
    },
    statistics: {
      title: '統計',
      description: 'ページの閲覧とウェブサイトの利用。再認識は行わず、IPアドレスも保存しません。'
    },
    marketing: {
      title: '分析と機械学習',
      description: '次回以降の訪問時の再認識、IPアドレス（おおよその所在地、ネットワーク事業者、組織）および端末の特性の分析。最後の訪問から12か月後まで保存します。その際、お客様のIPアドレスは、十分なデータ保護水準が認められていない米国、オーストラリアおよびモーリシャスのインターネットレジストリにも送信されます。現地の当局によるアクセスのリスク、およびお客様の権利の行使が困難になるリスクがあります。'
    },
    acceptAll: 'すべて同意する',
    rejectAll: '必須のみ',
    settings: '設定',
    save: '選択内容を保存',
    alwaysOn: '常に有効'
  },
  pages: {
    teaching: {
      hero: { title: 'エッジAI・EU AI Act研修', subtitle: '企業向けAIコンサルティング • エッジ開発 • 法令に準拠した導入' },
      intro: '経営層、プロジェクトマネージャー、開発チームを対象とした専門的なAI研修です。戦略コンサルティングから技術的な実装まで、EU AI Actに準拠した形で支援します。',
      eu_ai_act: { title: 'EU AI Actへの準拠とエッジコンピューティング', subtitle: 'ローカルでのデータ処理による、法的に確実なAI導入', description: 'EU AI Actは、欧州における人工知能の利用について厳格なルールを定めています。エッジコンピューティングは、その理想的な解決策です。機密データはローカルに留まり、コンプライアンス対応が簡素になり、AIシステムの管理はお客様の手元に残ります。', benefits: ['ローカル処理によるデータ保護', 'コンプライアンス対応の複雑さを軽減', 'AIの判断に対する完全なコントロール', '透明性と追跡可能性', '法的リスクの最小化', 'クラウド事業者からの独立'], highlight: 'エッジコンピューティング + EU AI Act = 妥協のない、法的に確実なAI' },
      offerings: { title: '研修プログラム', categories: [{ title: '人工知能と機械学習', icon: 'brain', topics: ['生成AIと大規模言語モデル（エッジおよびクラウド）', '従来型の機械学習（エッジ向けに最適化）', 'ディープラーニングとニューラルネットワーク（エッジへのデプロイ）', 'コンピュータビジョンとNLP（エッジ対応ソリューション）', 'RAGシステムとLLMのファインチューニング（エッジおよびクラウド）', '自律型AIエージェント（エッジコンピューティング）', 'EU AI Actへの準拠と法的確実性'] }, { title: 'データサイエンスと統計学', icon: 'chart', topics: ['記述統計と推測統計', 'データモデリングとデータ分析', '時系列分析', '経営学・経済学のための計量経済学', '自然科学のための生物統計学', 'A/Bテストと実験計画法'] }, { title: 'ソフトウェアアーキテクチャとセキュリティ', icon: 'shield', topics: ['モジュラーアーキテクチャ', '疎結合とクリーンコード', 'マイクロサービス設計', 'ITセキュリティとコンプライアンス', 'DevOpsとCI/CD', 'クラウドアーキテクチャ'] }] },
      target_groups: { title: '対象者', groups: [{ title: '経営層・意思決定者', description: 'AI戦略コンサルティング、コスト分析、投資判断', formats: ['エグゼクティブブリーフィング', 'ROI分析', '戦略コンサルティング'], focus: 'ビジネスケース、EU AI Actへの準拠、予算計画' }, { title: 'プロジェクトマネージャー・管理職', description: 'AIプロジェクトマネジメント、技術選定、導入戦略', formats: ['マネジメントワークショップ', '技術アセスメント', 'ロードマップ策定'], focus: 'プロジェクト計画、ベンダー選定、リスクマネジメント' }, { title: 'IT開発者・エンジニア', description: '実践的なエッジAI開発、技術的な実装、デプロイ', formats: ['テクニカルディープダイブ', 'コードレビュー', 'アーキテクチャワークショップ'], focus: 'エッジコンピューティング、LLMのファインチューニング、システム統合' }, { title: '業務部門の担当者', description: 'AIの理解、プロンプトの技法、日常業務での実践的な活用', formats: ['ユーザー研修', 'プロンプトワークショップ', 'ユースケース開発'], focus: '実務での活用、ワークフローへの統合、生産性の向上' }, { title: '学生・研究者', description: '大学での講義、個別指導、学術プロジェクトの指導', formats: ['講義', 'チュータリング', '論文指導'], focus: '統計学、計量経済学、研究手法' }] },
      expertise: { title: '技術的な専門性', items: ['企業向けAI戦略ロードマップの策定', 'RAG/GRAGアーキテクチャとLoRA/QLoRAファインチューニングによるエッジAIシステム', 'EU AI Actへの準拠戦略と法的に確実な導入', 'AIプロジェクトのROI分析と投資計画', 'ツールセットと推論能力を備えた自律型AIエージェント', '組織へのAI導入のためのチェンジマネジメント', 'クラウドおよびオンプレミスの戦略（Azure、STACKIT）', 'プロンプトエンジニアリングとワークフローの最適化'] },
      technologies: { title: '技術スタック', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' },
      clients: { title: '業界・機関', sectors: ['健康保険', '出版', '銀行・フィンテック', '産業・IoT', '研究機関・大学', 'コンサルティング', 'スタートアップ'] },
      workshops: { title: '実施形式', formats: [{ title: 'エグゼクティブブリーフィング', duration: '2〜4時間', description: 'ROIとEU AI Actに重点を置いた、経営層向けの戦略的な概要説明' }, { title: 'マネジメントワークショップ', duration: '1〜2日', description: 'AI導入とチェンジマネジメントに関するプロジェクトマネージャー向け研修' }, { title: 'テクニカルディープダイブ', duration: '2〜5日', description: 'ITチームとエンジニア向けの実践的なエッジAI開発' }, { title: 'ユーザー研修', duration: '0.5〜1日', description: '業務部門の担当者向けの実践的なAI活用' }, { title: '個別コーチング', duration: '必要に応じて', description: '個別のサポートとプロジェクト支援' }] },
      sidebar: {languagesLabel: '言語：', languagesValue: 'DE / EN / NL', focusLabel: '重点：', specializationTitle: '専門領域', specializationItems: ['クラウドに依存しないローカルデータ処理のためのエッジAI', '法的確実性のためのEU AI Act準拠の導入'], benefitsTitle: 'メリット', benefits: ['対象者に合わせた内容', 'すぐに実務で活用可能', 'ROI重視', 'リモートまたはオンサイト'] },
      cta: { title: '戦略的なAIトランスフォーメーションに向けた準備はお済みですか？', description: '経営層向けのコンサルティングから技術的な実装まで、お客様の具体的な要件についてぜひご相談ください。', button: 'コンサルティングを依頼', email: 'info@paioneer.eu', subject: '研修に関するお問い合わせ' }
    },
    agenticdev: {
      seo: { title: 'エージェント型コーディングのためのIntent-Driven Development（IDD） | pAIoneer Labs GmbH', description: 'Intent-Driven Developmentは、AI支援ソフトウェア開発を制御可能にします。意味、意思決定、シナリオが、エージェント型コーディングにおいて実務で機能する成果物になります。', keywords: 'Intent-Driven Development, Intent Driven Development, IDD, エージェント型コーディング, エージェント型ソフトウェア開発, AI支援ソフトウェア開発, バイブコーディング, Spec-Driven Development, 仕様駆動開発, プロンプトエンジニアリング, AIを活用した要件定義', ogTitle: 'Intent-Driven Development：実装より先に、意味を', ogDescription: 'IDDは、コードを書く前にコンテキストを運用可能な形にします。意図、意思決定、シナリオが、エージェント型ソフトウェア開発におけるプロジェクトの記憶になります。', twitterTitle: 'エージェント型コーディングのためのIntent-Driven Development（IDD）', twitterDescription: 'プロンプトの混乱ではなく、制御可能なコードを。IDDは、意味、意思決定、シナリオを実務で機能する成果物に変えます。', url: 'https://paioneer-labs.eu/agenticdev', structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'エージェント型コーディングのためのIntent-Driven Development（IDD）', serviceType: 'エージェント型ソフトウェア開発およびAI支援開発プロセス', description: 'Intent-Driven Development、IDD Vault、エージェント型コーディングのワークフロー、検証可能なAI支援ソフトウェア開発に関するコンサルティングと導入支援。', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' } },
      hero: { eyebrow: 'エージェント型コーディングには、明示的なコンテキストが必要です', title: 'Intent-Driven Development', claim: '実装より先に、意味を。', lead: 'AIはコードを書きます。IDDは、AIが正しい問題に取り組むようにします。Intent-Driven Developmentは、目標、境界、意思決定、シナリオを、エージェント型ソフトウェア開発において実務で機能する成果物に変えます。' },
      implicitContextProblem: { title: 'リスクは、暗黙のコンテキストにあります', intro: 'AI支援ソフトウェア開発における本当のリスクは、コードが足りないことではありません。誰かの頭の中やチャット履歴、散在するチケットに埋もれたままのコンテキストこそがリスクです。', items: [{ title: '不明確な依頼', description: 'プロンプトは解決策を説明することが多い一方で、目標、非目標、成功基準、前提条件までは説明しません。その結果、AIは素早く作業しますが、正しい方向に進むとは限りません。' }, { title: '成り行きのアーキテクチャ', description: '技術的な意思決定が、ついでのように行われます。永続化、モデルの選択、障害モード、運用が、意識的に主導されることなく、暗黙のうちに決まってしまいます。' }, { title: '検証できない結果', description: 'シナリオと受け入れ基準がなければ、コードが本当に正しく動作するのか、もっともらしく見えるだけなのかは分からないままです。' }], resolution: 'IDDが解決するのは、まさにこの問題です。まず意味を運用可能な形にし、そのうえでコードをそこから導き出します。' },
      antiVibeCoding: { title: 'バイブコーディングは開発プロセスではありません', description: 'デモであれば、直感だけで足りるかもしれません。しかし、運用、保守、セキュリティ、コスト、説明責任を伴うソフトウェアには、それでは足りません。エージェントに必要なのは、さらなる「雰囲気」ではなく、明示的なコンテキストです。', contrasts: ['バイブコーディングが生むのは動きです。IDDが生むのは方向性です。', 'プロンプティングが生むのは回答です。IDDが生むのはプロジェクトの記憶です。', 'IDDのないエージェント型コーディングは、単なる活動にとどまります。IDDを伴うエージェント型コーディングは、制御可能な開発になります。'] },
      principle: { title: 'ドキュメントは副産物ではありません', thesis: 'IDDにおいて、ドキュメントは実務で機能する成果物です。', description: 'ドキュメントは報告のためのものではありません。エージェントが実装に入る前に、目標、境界、意思決定、期待される振る舞いを明示するための作業空間です。', pillarsTitle: '意図。意思決定。シナリオ。コード。', pillarsIntro: 'IDDは、ソフトウェア開発をプロンプトだけに切り詰めません。プロジェクトの意味を明示し、そこから検証可能な実装を導き出します。', pillars: [{ title: '意図', description: '何を達成すべきか。何を明確に対象外とするか。成功をどのように判断するか。' }, { title: '意思決定', description: 'どのような重要な意思決定が、どのような文脈で、どのような帰結を伴って下されたか。' }, { title: 'シナリオ', description: '通常のケース、エッジケース、障害モード、受け入れの場面で、どのような振る舞いが期待されるか。' }, { title: 'コード', description: '実装は文書化された意味から生み出され、シナリオと検証手順に照らして確認されます。' }] },
      vault: { title: 'IDD Vault：プロンプト履歴ではなく、プロジェクトの記憶', description: 'IDD Vaultは、エージェントと人が再利用できる場所に、必要なコンテキストを保持します。ファイルは必要最小限にとどめます。どのファイルにも明確な役割があります。', rule: '少ない成果物。明確な役割。持続するコンテキスト。', effect: 'Vaultは、決定的に重要なコンテキストが、チャットや誰かの頭の中、散在するチケットの中に消えてしまうのを防ぎます。', treeLines: ['/project', '  /idd_vault', '    intent.md       # 目標、非目標、成功基準、前提条件', '    decisions.md    # 文脈、根拠、帰結を伴う意思決定', '    scenarios.md    # 振る舞い、エッジケース、受け入れ基準', '  /code', '  AGENTS.md         # コードエージェント向けのルールと期待事項', '  README.md         # 入口、セットアップ、運用モード、境界'] },
      outputs: { title: '文章ではなく、制御可能なコードを。', description: 'IDDのファイルは報告書ではありません。具体的な実装作業のためのインプットであり、得られた知見をプロジェクトに還元するためのものです。', items: [{ file: 'intent.md', result: 'スコープ', description: 'エンドポイント、データモデル、成功基準、非目標、前提条件が、開発の枠組みとして可視化されます。' }, { file: 'decisions.md', result: 'アーキテクチャ', description: '技術、運用、永続化、モデルの選択、トレードオフが、ついでに決められるのではなく、根拠をもって決定されます。' }, { file: 'scenarios.md', result: 'テスト', description: '受け入れテスト、障害モード、状態遷移、エッジケースが、実装の前または実装中に明らかになります。' }, { file: 'AGENTS.md', result: 'コード品質', description: 'ルール、パターン、制約、マイグレーション、OpenAPI、期待される出力が、エージェントに対して明示されます。' }, { file: 'README.md', result: '入口', description: 'セットアップ、運用モード、境界、フローの例が、人にもエージェントにも理解できる形で保たれます。' }, { file: 'コード', result: 'フィードバックループ', description: '実装と検証から得られた知見が、Vault、テスト、次のイテレーションに還元されます。' }] },
      comparison: { title: 'IDDは、仕様の手前から始まります', intro: 'Spec-Driven Development（仕様駆動開発）は、目標がすでに技術的に明確で安定している場合に力を発揮します。IDDはそれより手前、つまりドメイン、前提条件、トレードオフ、障害モードをこれから明示しなければならない段階から始まります。', columns: ['アプローチ', '中心', '強み', '限界'], rows: [{ approach: 'プロンプティング', center: 'モデルへの入力', strength: '高速かつ直接的', limit: '一時的で不完全、検証が困難' }, { approach: 'バイブコーディング', center: '直感と反復', strength: '試行やデモに有用', limit: '責任を負うべきソフトウェアに求められる、確かな制御がない' }, { approach: 'Spec-Driven Development', center: '技術的な契約', strength: 'すでに定義された仕様に対する一貫性', limit: '誤った問題が、形式上は正しく実装されるおそれ' }, { approach: 'Intent-Driven Development', center: '意味、目標、意思決定', strength: '実装の前に、コンテキスト、トレードオフ、境界を明確化', limit: 'コンテキストの継続的な整備と検証に、規律が必要' }], summary: '仕様は、技術的に何が成り立つべきかを示します。IDDは、なぜまさにその方向で作るべきなのかを説明します。' },
      workflow: { title: '明確にする。決める。記述する。作る。還元する。', description: 'IDDはウォーターフォールではありません。持続するコンテキストを伴う、小さく制御された反復です。', steps: [{ title: '意図を明確にする', description: 'コードを書く前に、目標、非目標、成功基準、前提条件を可視化します。' }, { title: '意思決定を文書化する', description: 'アーキテクチャとプロダクトに関する意思決定を、文脈、根拠、帰結とともに記録します。' }, { title: 'シナリオを記述する', description: '通常の振る舞い、エッジケース、障害モード、受け入れ基準を、検証可能な形で記述します。' }, { title: 'エージェントに実装させる', description: 'AIエージェントは、孤立したプロンプトではなく、明示的なコンテキストに基づいて作業します。' }, { title: '検証して還元する', description: 'コード、テスト、運用から得られた知見で、Vaultと次のイテレーションを更新します。' }] },
      impact: { title: '実際のプロジェクトでこれが重要な理由', description: 'IDDは、AI支援開発をチーム、運用、品質保証と結びつけられるものにします。', items: ['目標と非目標が見えているため、手戻りが減ります。', '意思決定に根拠があるため、アーキテクチャが良くなります。', 'コードより先にシナリオがあるため、テストが良くなります。', 'コンテキストがチャットの中に消えないため、協業が円滑になります。', 'すべてのステップが明示的な成果物に基づくため、エージェントの成果が向上します。'] },
      contact: { title: 'エージェント型の開発プロセスにIDDを導入する', description: 'AI支援開発を実験にとどめないためには、実務で機能するコンテキストモデルが必要です。', details: '当社は、IDD Vault、エージェントルール、シナリオ、検証可能な開発ワークフローの構築を支援します。', button: 'IDDについて相談する', subject: 'Intent-Driven Developmentについての相談', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('ja', baseTranslationJA)
  }
};
